{
  "addons.addonList": "Zoznam doplnkov",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Vytvorte a získajte svoj kľúč API z tohto odkazu",
  "addons.ambientWeatherDescription": "Ambient meteorologické stanice (Vantage Vue, Vantage Pro2, ...)",
  "addons.apiKey": "API kľúč",
  "addons.applicationKey": "Aplikačný kľúč",
  "addons.connect": "Pripojiť",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Kľúč API V2",
  "addons.davisDescription": "Davis meteorologické stanice (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "Získajte svoje kľúče API V2 z tohto odkazu",
  "addons.disconnect": "Odpojiť",
  "addons.ecowittCreateAndRetrieveKeys": "Vytvorte a získajte kľúč API aj kľúč aplikácie z tohto odkazu",
  "addons.ecowittDescription": "Ecowitt poskytuje profesionálnu wifi meteostanicu, bezdrôtové vnútorné a vonkajšie teplomery, monitory vlhkosti, vysoko presné dažďové meradlá, monitory kvality vzduchu a ďalšie.",
  "addons.helpLink": "Ako pripojiť {provider}",
  "addons.myAcuriteAccountOnHold": "Váš účet bol pozastavený. Ak chcete znova pripojiť svoj účet, zadajte svoje heslo",
  "addons.myAcuriteDescription": "AcuRite je značka číslo 1 v Severnej Amerike. Ako líder v technológii času, teploty a počasia vám AcuRite poskytuje podrobné informácie o vašom vnútornom a vonkajšom prostredí, aby ste si mohli s istotou naplánovať svoj deň.",
  "addons.myAcuriteEnterCredentials": "Zadajte svoje poverenia My AcuRite, aby ste prepojili svoj účet My AcuRite so SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Použite svoj termostat Netatmo na zmenu teploty vášho domova, či už z postele alebo z druhého konca sveta.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaša osobná meteorologická stanica doma",
  "addons.or": "alebo",
  "addons.providerAccountDisconnected": "Pripojenie k vašej meteorologickej službe vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "addons.reconnect": "Znovu sa pripojte",
  "addons.weatherflowCreateToken": "Vytvorte a získajte svoj token z tohto odkazu",
  "addons.weatherflowTempestDescription": "Tempest Weather System so vstavaným meračom vetra a dažďovým meračom",
  "addons.wundergroundApiKey": "Kľúč API",
  "addons.wundergroundDescription": "Weather Underground je globálna komunita ľudí, ktorí spájajú údaje z environmentálnych senzorov, ako sú meteorologické stanice a monitory kvality ovzdušia, aby sme vám mohli poskytnúť bohaté, hyperlokálne údaje, ktoré potrebujete na to, aby ste podporili svoje vášne.",
  "addons.wundergroundRetrieveApiKey": "Získajte kľúč API z tohto odkazu",
  "addons.wundergroundRetrieveStationId": "Získajte ID svojej stanice z tohto odkazu",
  "addons.wundergroundStationId": "ID stanice",
  "airQuality.adviceActivityGood": "Ideálny deň na pohyb vonku",
  "airQuality.adviceActivityHazardous": "Vyhnite sa akejkoľvek fyzickej aktivite vonku",
  "airQuality.adviceActivityLabel": "Fyzická aktivita",
  "airQuality.adviceActivityModerate": "Dobrý deň na pohyb vonku",
  "airQuality.adviceActivitySensitive": "Zvážte kratšie a menej náročné aktivity vonku",
  "airQuality.adviceActivityUnhealthy": "Obmedzte dlhé alebo náročné aktivity a robte viac prestávok",
  "airQuality.adviceActivityVeryUnhealthy": "Vyhnite sa dlhým alebo náročným aktivitám; zvážte presun dovnútra",
  "airQuality.adviceGroupsGood": "Nie sú potrebné žiadne zvláštne opatrenia",
  "airQuality.adviceGroupsHazardous": "Zostaňte vnútri a obmedzte aktivitu",
  "airQuality.adviceGroupsLabel": "Citlivé skupiny",
  "airQuality.adviceGroupsModerate": "Nezvyčajne citliví ľudia: kratšie a menej náročné aktivity",
  "airQuality.adviceGroupsSensitive": "Kratšie a menej náročné aktivity vonku a viac prestávok",
  "airQuality.adviceGroupsUnhealthy": "Vyhnite sa dlhým alebo náročným aktivitám vonku; zvážte presun dovnútra",
  "airQuality.adviceGroupsVeryUnhealthy": "Vyhnite sa akejkoľvek fyzickej aktivite vonku; odložte ju alebo presuňte dovnútra",
  "airQuality.adviceTimingLabel": "Kedy ísť von",
  "airQuality.adviceTimingMorning": "Najlepšie dopoludnia — ozón je vtedy nižší",
  "airQuality.airQuality": "Kvalita ovzdušia",
  "airQuality.airQualityIndex": "Index kvality ovzdušia",
  "airQuality.aqiForecast": "Predpoveď kvality ovzdušia",
  "airQuality.co": "Oxid uhoľnatý",
  "airQuality.dailyForecast": "Denná predpoveď",
  "airQuality.details": "Podrobnosti",
  "airQuality.dominantPollutant": "Dominantná znečisťujúca látka",
  "airQuality.expectedPeak": "Očakávaný vrchol",
  "airQuality.good": "Dobrá",
  "airQuality.goodDescription": "Kvalita ovzdušia sa považuje za uspokojivú a znečistenie ovzdušia predstavuje malé alebo žiadne riziko",
  "airQuality.hazardous": "Nebezpečná",
  "airQuality.hazardousDescription": "Zdravotné upozornenie: ktokoľvek môže pociťovať vážnejšie zdravotné účinky",
  "airQuality.indoorAirQuality": "Kvalita vnútorného vzduchu",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Priemerná",
  "airQuality.moderateDescription": "Kvalita vzduchu je prijateľná; pri niektorých znečisťujúcich látkach však môže existovať mierny zdravotný problém u veľmi malého počtu ľudí, ktorí sú nezvyčajne citliví na znečistenie ovzdušia.",
  "airQuality.no2": "Oxid dusičitý",
  "airQuality.noForecastForLocation": "Pre toto miesto nie je k dispozícii predpoveď kvality ovzdušia.",
  "airQuality.now": "Teraz",
  "airQuality.o3": "Ozón",
  "airQuality.pm10": "Častice s priemerom 10 μm alebo menej",
  "airQuality.pm25": "Častice s priemerom 2,5 μm alebo menej",
  "airQuality.pollutants": "Znečisťujúce látky",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Odporúčania",
  "airQuality.sensitiveUnhealthy": "Nezdravá pre citlivých ľudí",
  "airQuality.sensitiveUnhealthyDescription": "Členovia citlivých skupín môžu pociťovať zdravotné účinky. Širokej verejnosti sa to pravdepodobne nedotkne.",
  "airQuality.so2": "Oxid siričitý",
  "airQuality.subIndex": "Čiastkový index AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Porozumieť indexu",
  "airQuality.unhealthy": "Nezdravá",
  "airQuality.unhealthyDescription": "Každý môže začať pociťovať účinky na zdravie; členovia citlivých skupín môžu pociťovať vážnejšie zdravotné účinky",
  "airQuality.veryUnhealthy": "Veľmi nezdravá",
  "airQuality.veryUnhealthyDezscription": "Zdravotné varovania pred núdzovými podmienkami. Je pravdepodobnejšie, že bude postihnutá celá populácia.",
  "alerts.addAlert": "Pridať upozornenie",
  "alerts.addCondition": "Pridať podmienku",
  "alerts.alertAdded": "Upozornenie bolo úspešne pridané",
  "alerts.alertAuthorizationNotice": "Upozornenia fungujú iba vtedy, ak povolíte SmartMixin na zobrazovanie upozornení",
  "alerts.alertDeleted": "Upozornenie bolo úspešne odstránené",
  "alerts.alertEdited": "Upozornenie bolo úspešne upravené",
  "alerts.alertName": "Názov upozornenia",
  "alerts.alertWhen": "Chcem byť upozornený, keď:",
  "alerts.aqiGreaterThan": "AQI viac ako",
  "alerts.aqiGreaterThanThreshold": "AQI je vyššie ako prahová hodnota {value}{unit}",
  "alerts.aqiLessThan": "AQI menej ako",
  "alerts.aqiLessThanThreshold": "AQI je menej ako prahová hodnota {value}{unit}",
  "alerts.atLeastOneCondition": "Musíte pridať aspoň jednu podmienku",
  "alerts.co2GreaterThan": "CO2 viac ako",
  "alerts.co2GreaterThanThreshold": "CO2 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.co2LessThan": "CO2 menej ako",
  "alerts.co2LessThanThreshold": "CO2 je menej ako prahová hodnota {value}{unit}",
  "alerts.conditions": "Podmienky",
  "alerts.createAlert": "Vytvoriť upozornenie",
  "alerts.dailyPrecipitationGreaterThan": "Denné zrážky väčšie ako",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Denné zrážky nad prahom {value}{unit}",
  "alerts.deleteAlert": "Odstrániť upozornenie",
  "alerts.editAlert": "Upraviť upozornenie",
  "alerts.editCondition": "Upraviť podmienku",
  "alerts.gustSpeedGreaterThan": "Rýchlosť nárazu väčšia ako",
  "alerts.gustSpeedGreaterThanThreshold": "Rýchlosť nárazu vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.gustSpeedLessThan": "Rýchlosť nárazu menšia ako",
  "alerts.gustSpeedLessThanThreshold": "Rýchlosť nárazu vetra je nižšia ako prahová hodnota {value}{unit}",
  "alerts.heatIndexGreaterThan": "Tepelný index viac ako",
  "alerts.heatIndexGreaterThanThreshold": "Tepelný index je viac ako prahová hodnota {value}{unit}",
  "alerts.heatIndexLessThan": "Tepelný index menej ako",
  "alerts.heatIndexLessThanThreshold": "Tepelný index je menej ako prahová hodnota {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex viac ako",
  "alerts.humidexGreaterThanThreshold": "Humidex je viac ako prahová hodnota {value}{unit}",
  "alerts.humidexLessThan": "Humidex menej ako",
  "alerts.humidexLessThanThreshold": "Humidex je menej ako prahová hodnota {value}{unit}",
  "alerts.humidityGreaterThan": "Vlhkosť väčšia ako",
  "alerts.humidityGreaterThanThreshold": "Vlhkosť je vyššia ako prahová hodnota {value}{unit}",
  "alerts.humidityLessThan": "Vlhkosť menšia ako",
  "alerts.humidityLessThanThreshold": "Vlhkosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.inProgress": "Prebieha",
  "alerts.myAlerts": "Moje upozornenia",
  "alerts.noConfiguredAlert": "Zatiaľ nemáte nakonfigurované žiadne upozornenia, pridajte si ich",
  "alerts.noiseGreaterThan": "Hluk vyšší ako",
  "alerts.noiseGreaterThanThreshold": "Hluk je vyšší ako prahová hodnota {value}{unit}",
  "alerts.noiseLessThan": "Hluk nižší ako",
  "alerts.noiseLessThanThreshold": "Hluk nižší ako prahová hodnota {value}{unit}",
  "alerts.noteOnConditions": "Upozornenie sa spustí, keď sa overia všetky nižšie uvedené podmienky",
  "alerts.noTriggerHistory": "Toto upozornenie zatiaľ nebolo spustené.",
  "alerts.pm10GreaterThan": "PM 10 viac ako",
  "alerts.pm10GreaterThanThreshold": "PM 10 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm10LessThan": "PM 10 menej ako",
  "alerts.pm10LessThanThreshold": "PM 10 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 viac ako",
  "alerts.pm1GreaterThanThreshold": "PM 1 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm1LessThan": "PM 1 menej ako",
  "alerts.pm1LessThanThreshold": "PM 1 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 viac ako",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 menej ako",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 je menej ako prahová hodnota {value}{unit}",
  "alerts.postStormSummary": "Súhrn po daždi",
  "alerts.postStormSynopsisHelper": "Po skončení každého dažďa dostanete súhrnné oznámenie.",
  "alerts.postStormSynopsisSoleCondition": "Súhrn po búrke nemožno kombinovať s inými podmienkami.",
  "alerts.precipitationGreaterThan": "Hodinové zrážky väčšie ako",
  "alerts.precipitationGreaterThanThreshold": "Hodinové zrážky nad prahom {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak väčší ako",
  "alerts.pressureGreaterThanThreshold": "Tlak je vyšší ako prahová hodnota {value}{unit}",
  "alerts.pressureLessThan": "Tlak menší ako",
  "alerts.pressureLessThanThreshold": "Tlak je nižší ako prahová hodnota {value}{unit}",
  "alerts.rainRateGreaterThan": "Intenzita dažďa väčšia ako",
  "alerts.rainRateGreaterThanThreshold": "Intenzita dažďa nad prahom {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Slnečné žiarenie väčšie ako",
  "alerts.solarRadiationGreaterThanThreshold": "Slnečné žiarenie je vyššie ako prahová hodnota {value}{unit}",
  "alerts.solarRadiationLessThan": "Slnečné žiarenie menej ako",
  "alerts.solarRadiationLessThanThreshold": "Slnečné žiarenie je nižšie ako prahová hodnota {value}{unit}",
  "alerts.stormChartUnavailable": "História zrážok pre tento dážď nie je k dispozícii.",
  "alerts.stormDetail": "Súhrn dažďa",
  "alerts.stormDuration": "Trvanie",
  "alerts.stormEnd": "Koniec",
  "alerts.stormPeakRate": "Maximálna intenzita dažďa",
  "alerts.stormStart": "Začiatok",
  "alerts.stormTotal": "Celkové zrážky",
  "alerts.temperatureGreaterThan": "Teplota vyššia ako",
  "alerts.temperatureGreaterThanThreshold": "Teplota je vyššia ako prahová hodnota {value}{unit}",
  "alerts.temperatureLessThan": "Teplota nižšia ako",
  "alerts.temperatureLessThanThreshold": "Teplota je nižšia ako prahová hodnota {value}{unit}",
  "alerts.thswGreaterThan": "THSW viac ako",
  "alerts.thswGreaterThanThreshold": "THSW je viac ako prahová hodnota {value}{unit}",
  "alerts.thswLessThan": "THSW menej ako",
  "alerts.thswLessThanThreshold": "THSW je menej ako prahová hodnota {value}{unit}",
  "alerts.thwGreaterThan": "THW viac ako",
  "alerts.thwGreaterThanThreshold": "THW je viac ako prahová hodnota {value}{unit}",
  "alerts.thwLessThan": "THW menej ako",
  "alerts.thwLessThanThreshold": "THW je menej ako prahová hodnota {value}{unit}",
  "alerts.triggerHistory": "História upozornenia",
  "alerts.uvGreaterThan": "UV index väčší ako",
  "alerts.uvGreaterThanThreshold": "UV index je vyšší ako prahová hodnota {value}{unit}",
  "alerts.uvLessThan": "UV index nižší ako",
  "alerts.uvLessThanThreshold": "UV index je nižší než prahová hodnota {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Viditeľnosť je väčšia ako prahová hodnota {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Viditeľnosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.visiblityGreaterThan": "Viditeľnosť väčšia ako",
  "alerts.visiblityLessThan": "Viditeľnosť menšia ako",
  "alerts.whichMeasure": "Na ktoré meranie chcete byť upozornení?",
  "alerts.whichModule": "Na ktorý modul by ste chceli byť upozornení?",
  "alerts.windChillGreaterThan": "Ochladenie vetra viac ako",
  "alerts.windChillGreaterThanThreshold": "Ochladenie vetra je viac ako prahová hodnota {value}{unit}",
  "alerts.windChillLessThan": "Ochladenie vetra menej ako",
  "alerts.windChillLessThanThreshold": "Ochladenie vetra je menej ako prahová hodnota {value}{unit}",
  "alerts.windSpeedGreaterThan": "Rýchlosť vetra väčšia ako",
  "alerts.windSpeedGreaterThanThreshold": "Rýchlosť vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.windSpeedLessThan": "Rýchlosť vetra menšia ako",
  "alerts.windSpeedLessThanThreshold": "Rýchlosť vetra je nižšia ako prahová hodnota {value}{unit}",
  "astral.aboveHorizonAllDay": "Celý deň nad obzorom",
  "astral.aboveTheHorizon": "nad obzorom",
  "astral.apparentSize": "Uhlová veľkosť",
  "astral.apparentSizeAcross": "s priemerom {size}",
  "astral.astronomicalDawn": "Astronomický úsvit",
  "astral.astronomicalDusk": "Astronomický súmrak",
  "astral.astronomicalSunPhase": "Astronomický {sunPhase}",
  "astral.belowHorizonAllDay": "Celý deň pod obzorom",
  "astral.belowHorizonSince": "Pod obzorom od {time}",
  "astral.belowHorizonSinceOn": "Pod obzorom od {day} {time}",
  "astral.brightAllNight": "Svetlá obloha celú noc — nikdy úplná tma",
  "astral.brightestMoment": "Najsvetlejší okamih",
  "astral.civilDawn": "Občiansky úsvit",
  "astral.civilDusk": "Občiansky súmrak",
  "astral.civilSunPhase": "Občiansky {sunPhase}",
  "astral.darkSkyBetween": "Tmavá obloha {from} → {to}",
  "astral.darkSkyWindow": "Tmavá obloha {from} → {to} · {duration} bez Mesiaca",
  "astral.dawn": "Svitanie",
  "astral.dayLength": "Dĺžka dňa",
  "astral.daylightThroughTheYear": "Dĺžka dňa počas roka",
  "astral.dayOfCycle": "deň {day} z {total}",
  "astral.doesNotOccurToday": "Dnes nenastáva",
  "astral.domeHint": "Ťahaním prejdite nocou",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Súmrak",
  "astral.earliestSunrise": "Najskorší východ slnka",
  "astral.earliestSunset": "Najskorší západ slnka",
  "astral.equinox": "Rovnodennosť",
  "astral.equinoxIn": "Rovnodennosť o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Presne o {time}",
  "astral.firstQuarter": "Prvá štvrť",
  "astral.firstSunriseIn": "Prvý východ slnka o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.firstSunsetIn": "Prvý západ slnka o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.fullMoon": "Spln",
  "astral.goldenHourBegins": "Začiatok zlatej hodiny",
  "astral.goldenHourEnds": "Koniec zlatej hodiny",
  "astral.highestPoint": "Najvyšší bod",
  "astral.inDays": "o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.lastQuarter": "Posledná štvrť",
  "astral.latestSunrise": "Najneskorší východ slnka",
  "astral.latestSunset": "Najneskorší západ slnka",
  "astral.litShort": "Osvetl.",
  "astral.longestDay": "Najdlhší deň",
  "astral.lowestPoint": "Najnižší bod",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Poludnie",
  "astral.midnightSun": "Polnočné slnko",
  "astral.midnightSunPeriod": "Polnočné slnko",
  "astral.milestoneFootnotePolar": "Slnko tu {days, plural, one {# deň} few {# dni} other {# dní}} v roku nevychádza ani nezapadá, a tak zoznam namiesto obvyklých extrémov východu a západu ukazuje, kedy k tomu dochádza.",
  "astral.milestoneFootnoteTemperate": "Najskorší západ a najneskorší východ nepripadajú na najkratší deň — tieto dva dátumy určuje časová rovnica, nie slnovrat.",
  "astral.moon": "Mesiac",
  "astral.moonAltitude": "Výška",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Vzdialenosť",
  "astral.moonlessFor": "{duration} bez Mesiaca",
  "astral.moonPhases": "Fázy Mesiaca",
  "astral.moonrise": "Východ Mesiaca",
  "astral.moonset": "Západ Mesiaca",
  "astral.moonUpAllNight": "Mesiac je nad obzorom celú noc",
  "astral.moonWashesOutNight": "Mesiac je nad obzorom od {rise} do {set} a presvetľuje celú noc",
  "astral.morning": "Ráno",
  "astral.nauticalDawn": "Nautický úsvit",
  "astral.nauticalDusk": "Nautický súmrak",
  "astral.nauticalSunPhase": "Námorná {sunPhase}",
  "astral.newMoon": "Nov",
  "astral.nextDay": "+1 deň",
  "astral.nextProperlyDarkNight": "Najbližšia naozaj tmavá noc",
  "astral.nextRise": "najbližší východ o {time}",
  "astral.nextRiseOn": "najbližší východ {day} o {time}",
  "astral.nextSevenNights": "Najbližších sedem nocí",
  "astral.noAstronomicalDarknessTonight": "Dnes v noci žiadna astronomická tma",
  "astral.noDarkNightAhead": "Žiadna v najbližších dvoch týždňoch",
  "astral.noon": "Poludnie",
  "astral.noSunriseToday": "Dnes slnko nevychádza",
  "astral.nowAtBearing": "teraz {altitude} · azimut {direction}",
  "astral.observing": "Pozorovanie",
  "astral.ofDaylightLeft": "denného svetla zostáva",
  "astral.overTheNextThreeWeeks": "počas najbližších 3 týždňov",
  "astral.percentLit": "osvetlenie {percent}",
  "astral.polarNight": "Polárna noc",
  "astral.polarNightPeriod": "Polárna noc",
  "astral.remainingDaylight": "Zostávajúce denné svetlo",
  "astral.rightNow": "Práve teraz",
  "astral.riseShort": "Východ",
  "astral.setShort": "Západ",
  "astral.shortestDay": "Najkratší deň",
  "astral.solarNoon": "Pravé poludnie",
  "astral.solstice": "Slnovrat",
  "astral.sunBelowHorizon": "Slnko {degrees}° pod obzorom",
  "astral.sunEvents": "Slnečné udalosti",
  "astral.sunNeverDarkEnough": "Slnko nikdy neklesne 18° pod obzor",
  "astral.sunNeverSets": "Slnko nezapadá",
  "astral.sunrise": "Východ slnka",
  "astral.sunriseAndSunset": "Východ a západ slnka",
  "astral.sunriseAt": "Východ slnka o {time}",
  "astral.sunset": "Západ slnka",
  "astral.sunsetAt": "Západ slnka o {time}",
  "astral.thisYearAtNorth": "Tento rok na {degrees}° s. š.",
  "astral.thisYearAtSouth": "Tento rok na {degrees}° j. š.",
  "astral.tonight": "Dnes v noci",
  "astral.totalDaylight": "Celkové denné svetlo",
  "astral.twilightAllNight": "Súmrak celú noc — nikdy úplná tma",
  "astral.upFor": "{duration} nad obzorom",
  "astral.usableLight": "Využiteľné svetlo",
  "astral.vsAverage": "{percent} oproti priemeru",
  "astral.vsYesterday": "oproti včerajšku",
  "astral.waningCrescent": "Cúvajúci kosáčik",
  "astral.waningGibbous": "Cúvajúci Mesiac",
  "astral.waxingCrescent": "Dorastajúci kosáčik",
  "astral.waxingGibbous": "Dorastajúci Mesiac",
  "astral.whereToLook": "Kam sa pozerať",
  "astral.withoutTheMoon": "{duration} bez Mesiaca",
  "auth.alreadyHaveAccount": "Už máte účet?",
  "auth.authContainerTagline": "Váš osobný panel počasia. Pripojte svoje stanice a získajte údaje v reálnom čase na dosah ruky.",
  "auth.backToLogin": "Späť na prihlásenie",
  "auth.catchPhrase": "Platforma meteorologickej inteligencie",
  "auth.checkYourEmail": "Skontrolujte svoj e-mail",
  "auth.continueWithApple": "Pokračovať cez Apple",
  "auth.continueWithFacebook": "Pokračovať cez Facebook",
  "auth.continueWithGoogle": "Pokračovať cez Google",
  "auth.email": "Emailová adresa",
  "auth.emailRequiredLoginFacebook": "Vyžaduje sa emailové povolenie.",
  "auth.emailVerification": "Overenie e-mailom",
  "auth.emailVerificationFailure": "Vyskytol sa problém s overením vášho emailu.",
  "auth.emailVerificationSuccess": "Váš email bol úspešne overený.",
  "auth.firstName": "Meno",
  "auth.forgotPassword": "Zabudli ste heslo?",
  "auth.forgotPasswordSubtitle": "Zadajte svoj e-mail a pošleme vám odkaz na resetovanie hesla.",
  "auth.lastName": "Priezvisko",
  "auth.login": "Prihlásiť sa",
  "auth.loginSubtitle": "Vitajte späť! Prosím, zadajte svoje údaje.",
  "auth.loginToSmartMixinDescription": "Ak chcete získať prístup k svojmu účtu, zadajte svoje poverenia SmartMixin.",
  "auth.logout": "Odhlásiť sa",
  "auth.logoutConfirmation": "Naozaj sa chcete odhlásiť?",
  "auth.noAccountYet": "Ešte nemáte účet?",
  "auth.or": "alebo",
  "auth.password": "Heslo",
  "auth.passwordAgain": "Opakovať heslo",
  "auth.passwordReset": "Resetovanie hesla",
  "auth.passwordResetSuccess": "Vaše heslo bolo úspešne aktualizované.",
  "auth.register": "Vytvoriť účet",
  "auth.registerDescription": "Vytvorte si bezplatný účet SmartMixin na pripojenie vašich meteorologických staníc, sledovanie údajov o počasí a prístup k výkonným analytickým nástrojom.",
  "auth.registerSubtitle": "Vytvorte si účet a začnite.",
  "auth.registerSuccess": "Úspešne ste sa zaregistrovali! Práve sme vám poslali overovací odkaz na adresu {emailAddress} s ďalšími pokynmi.",
  "auth.restorePassword": "Obnoviť heslo",
  "auth.restorePasswordSuccess": "Práve sme vám poslali odkaz na obnovenie hesla na adresu {emailAddress} s ďalšími pokynmi.",
  "auth.sendReset": "Odoslať pokyny na resetovanie",
  "auth.signInWithApple": "",
  "auth.socialAccount": "alebo použite svoj účet",
  "auth.welcome": "Vitajte v SmartMixin",
  "auth.welcomeBack": "Vitajte späť!",
  "calendar.april": "Apríl",
  "calendar.august": "August",
  "calendar.dateFormat": "Formát dátumu",
  "calendar.day": "Deň",
  "calendar.december": "December",
  "calendar.end": "Ukončiť",
  "calendar.february": "Február",
  "calendar.hours": "Hodiny",
  "calendar.hoursShort": "h",
  "calendar.january": "Január",
  "calendar.july": "Júl",
  "calendar.june": "Jún",
  "calendar.last24Hours": "trvať 24 hodín",
  "calendar.last30Days": "posledných 30 dní",
  "calendar.last7Days": "posledných 7 dní",
  "calendar.march": "Marec",
  "calendar.max": "Max",
  "calendar.may": "Máj",
  "calendar.month": "Mesiac",
  "calendar.months": "mesiace",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1-deň",
  "calendar.oneHour": "1-hodina",
  "calendar.oneMonth": "1-mesiac",
  "calendar.oneWeek": "1-týždeň",
  "calendar.previous24Hours": "Predchádzajúcich 24 hodín",
  "calendar.previous30Days": "Predchádzajúcich 30 dní",
  "calendar.previous7Days": "Predchádzajúcich 7 dní",
  "calendar.previousDay": "Predchádzajúci deň",
  "calendar.previousMonth": "Predchádzajúci mesiac",
  "calendar.previousWeek": "Predchádzajúci týždeň",
  "calendar.previousYear": "Predchádzajúci rok",
  "calendar.sameDayLastYear": "Ten istý deň minulého roku",
  "calendar.sameMonthLastYear": "Ten istý mesiac minulého roku",
  "calendar.selectADate": "Vyberte dátum",
  "calendar.selectAggregation": "Vyberte zobrazenú hodnotu",
  "calendar.selectAMonth": "Vyberte mesiac",
  "calendar.selectAYear": "Vyberte rok",
  "calendar.selectGranularity": "Vyberte podrobnosti",
  "calendar.selectTimescale": "Vyberte časové merítko",
  "calendar.september": "September",
  "calendar.sixHours": "6-hodín",
  "calendar.start": "Začiatok",
  "calendar.thirtyMinutes": "30-minút",
  "calendar.threeHours": "3-hodiny",
  "calendar.use24HourFormat": "Použiť 24-hodinový formát",
  "calendar.week": "Týždeň",
  "calendar.year": "Rok",
  "calendar.yesterday": "Včera",
  "common.accountDeleted": "Váš účet bol úspešne odstránený.",
  "common.accountOnHold": "Pripojenie vášho účtu vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "common.add": "Pridať",
  "common.addAStation": "Pridať stanicu",
  "common.addToFavorites": "Pridať k obľúbeným",
  "common.addYourOwnStation": "Pridajte vlastnú stanicu",
  "common.afternoon": "Popoludnie",
  "common.alreadyPremium": "Už máte prémiový účet!",
  "common.alsoAvailableOn": "K dispozícii aj na:",
  "common.altitude": "Nadmorská výška",
  "common.analysis": "Analýzy",
  "common.aroundMe": "Okolo mňa",
  "common.articleCount": "{count, plural, one {# článok} few {# články} many {# článkov} other {# článkov}}",
  "common.articleNotFound": "Článok nenájdený",
  "common.articleNotFoundDescription": "Článok, ktorý hľadáte, neexistuje.",
  "common.average": "Priemerná",
  "common.averageOverThePeriod": "Priemer za dané obdobie",
  "common.away": "Preč",
  "common.back": "Späť",
  "common.backToHelpCenter": "Späť do centra pomoci",
  "common.backToHome": "Späť na Hlavnú Stránku",
  "common.bad": "Zlý",
  "common.batteryLevel": "Úroveň nabitia batérie",
  "common.bestValue": "Najlepšia Hodnota",
  "common.billingDetailsAndroid": "V prípade bezplatnej skúšobnej ponuky vám nebudú účtované žiadne poplatky, ak ju zrušíte 24 hodín pred uplynutím bezplatného úvodného obdobia. Po skončení skúšobnej verzie môžete predplatné SmartMixin kedykoľvek zrušiť prostredníctvom nastavení účtu Google Play, alebo sa automaticky obnoví. Musíte to urobiť 24 hodín pred koncom obdobia predplatného, aby ste sa vyhli účtovaniu ďalšieho poplatku uvedeného v tlačidle vyššie. Platby za predplatné budú účtované na váš účet Google Play pri potvrdení vášho nákupu a na začiatku každého obdobia obnovenia.",
  "common.billingDetailsIos": "V prípade bezplatnej skúšobnej ponuky vám nebudú účtované žiadne poplatky, ak ju zrušíte 24 hodín pred uplynutím bezplatného úvodného obdobia. Po skončení skúšobnej verzie môžete predplatné SmartMixin kedykoľvek zrušiť prostredníctvom nastavení účtu App Store, alebo sa automaticky obnoví. Musíte to urobiť 24 hodín pred koncom obdobia predplatného, aby ste sa vyhli účtovaniu ďalšieho poplatku uvedeného v tlačidle vyššie. Platby za predplatné budú účtované na váš účet App Store pri potvrdení vášho nákupu a na začiatku každého obdobia obnovenia.",
  "common.boilerOn": "Kotol ZAPNUTÝ",
  "common.browseByCategory": "Prechádzať podľa kategórie",
  "common.calendarView": "Zobrazenie kalendára",
  "common.cancel": "Zrušiť",
  "common.cannotBeEmpty": "Toto pole nemôže byť prázdne.",
  "common.cardDetails": "Podrobnosti karty",
  "common.categoryNotFound": "Kategória nenájdená",
  "common.categoryNotFoundDescription": "Táto kategória neexistuje alebo neobsahuje žiadne články.",
  "common.charts": "Grafy",
  "common.chartView": "Zobrazenie grafu",
  "common.clearRecentLocations": "Vyčistiť",
  "common.close": "Zavrieť",
  "common.comparison": "Porovnanie",
  "common.contactMe": "Kontaktujte ma",
  "common.currentDay": "Aktuálny deň",
  "common.currentLocation": "Súčasná lokalita",
  "common.currentObservations": "Aktuálne hodnoty",
  "common.currentRainEvent": "Aktuálne dažďové udalosti",
  "common.currentRate": "Aktuálna sadzba",
  "common.currentWeatherConditions": "Súčasné podmienky",
  "common.customizeComparisonMetrics": "Prispôsobiť metriky",
  "common.customizeComparisonMetricsDescription": "Presuňte položky a znovu usporiadajte metriky porovnania. Klepnutím na ikonu oka môžete zobraziť alebo skryť metriky.",
  "common.customizeDashboard": "Prispôsobiť",
  "common.customizeDashboardDescription": "Potiahnutím položiek zmeníte poradie na nástenke. Klepnutím na ikonu oka zobrazíte alebo skryjete sekcie.",
  "common.customizedStationName": "Vlastný názov stanice",
  "common.dailyForecast": "Denná predpoveď",
  "common.dashboard": "Panel",
  "common.default": "Predvolené",
  "common.defaultForecastModelChip": "Predvolené · {name}",
  "common.delete": "Odstrániť",
  "common.deleteAccount": "Odstrániť účet",
  "common.deleteAccountConfirmation": "Naozaj chcete odstrániť svoj účet? Táto akcia je nezvratná.",
  "common.deleteAccountDescription": "Táto akcia odstráni váš účet a všetky vaše informácie. Už niet cesty späť.",
  "common.details": "Podrobnosti",
  "common.durationHours": "{hours} h",
  "common.durationHoursMinutes": "{hours} h {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.durationMinutesSeconds": "{minutes} min {seconds} s",
  "common.durationSeconds": "{seconds} s",
  "common.edit": "Upraviť",
  "common.editor": "Editor",
  "common.endTime": "Čas ukončenia",
  "common.evening": "Večer",
  "common.exitFullscreen": "Ukončiť celú obrazovku",
  "common.exploreWeatherMap": "Preskúmať Mapu Počasia",
  "common.favoriteLocations": "Obľúbené",
  "common.favoriteLocationsEmpty": "Môžete pridať až 5 obľúbených miest.",
  "common.favoriteStations": "Obľúbené stanice",
  "common.feedbackHelpsImprove": "Vaša spätná väzba nám pomáha zlepšovať naše články pomoci.",
  "common.feedbackReasonNotAnswer": "Neodpovedá na moju otázku",
  "common.feedbackReasonOutdated": "Informácie sú zastarané",
  "common.feedbackReasonUnclear": "Pokyny sú nejasné",
  "common.feedbackWhatWentWrong": "V čom bol problém?",
  "common.filterStationDescription": "Nezobrazujte stanice s nespoľahlivými meraniami",
  "common.filterStations": "Filtrovať stanice",
  "common.filterStationSourceDescription": "Vyberte poskytovateľov staníc, ktorých chcete zobraziť na mape",
  "common.findStationsNearYou": "Nájsť stanice vo vašom okolí",
  "common.firmwareVersion": "Verzia firmvéru",
  "common.forecast": "Predpoveď",
  "common.forecastAllModels": "Všetky modely ({count})",
  "common.forecastComparisonDescription": "Ľahko porovnávajte výstupy predpovedného modelu z viacerých zdrojov",
  "common.forecastFollowingPreferences": "Podľa vašich predvolieb",
  "common.forecastModelComparison": "Porovnanie predpovedných modelov",
  "common.forecastModelCoverage": "Pokrytie",
  "common.forecastModelDescription": "Popis",
  "common.forecastModelDescription_AROME": "Vysokorozlišovací model Météo France umožňujúci riešenie konvekcie nad západnou Európou s rozlíšením 1,3 km. Najlepší vo svojej triede pre krátkodobé predpovede vo Francúzsku; aktualizuje sa každé tri hodiny.",
  "common.forecastModelDescription_ARPEGE_EU": "Európske hniezdo modelu ARPEGE Météo France s rozlíšením 10 km. Strednodobé predpovede nad Európou, aktualizované štyrikrát denne.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Globálny numerický model počasia Météo France s rozlíšením 25 km, bežiaci asi 4 dni. Aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI od DMI: konvekciu umožňujúci model nad severozápadnou Európou — Dánsko, Benelux, Írsko, Spojené kráľovstvo a Škandinávia — s rozlíšením 2 km bežiaci až 60 hodín, aktualizovaný osemkrát denne. Obsahuje upravené otvorené dáta DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Globálny deterministický predpovedný systém Environment Canada: svetový strednodobý model s rozlíšením 15 km bežiaci až 10 dní, aktualizovaný dvakrát denne.",
  "common.forecastModelDescription_EC_HRDPS": "Vysoko rozlíšený deterministický predpovedný systém Environment Canada: konvekciu umožňujúci model nad Kanadou a severnou časťou Spojených štátov s rozlíšením 2,5 km bežiaci až 48 hodín, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_EC_RDPS": "Regionálny deterministický predpovedný systém Environment Canada: strednodobý model nad Severnou Amerikou s rozlíšením 10 km, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_ECMWF_HRES": "Vlajková loď medzi modelmi s vysokým rozlíšením (IFS) Európskeho centra pre strednodobé predpovede počasia, všeobecne považovaná za najlepší globálny predpovedný systém na svete. Pokrýva celú planétu v rozlíšení 25 km až na 15 dní, aktualizuje sa štyrikrát denne. Obsahuje upravené otvorené dáta ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Vlajkový strednodobý globálny model NOAA. Pokrýva celú planétu s rozlíšením 25 km až do 16 dní, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh NOAA: model umožňujúci riešenie konvekcie nad kontinentálnymi Spojenými štátmi s rozlíšením 3 km, aktualizovaný každú hodinu. Najvhodnejší pre veľmi krátkodobé predpovede búrok a silných meteorologických javov.",
  "common.forecastModelDescription_ICON": "Globálny model ICON od DWD s rozlíšením 13 km pokrývajúci celú planétu až na 7,5 dňa, aktualizovaný štyrikrát denne. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I od ItaliaMeteo, prevádzkovaný spolu s ARPAE: konvekciu umožňujúci model nad Talianskom s rozlíšením 2,2 km bežiaci až 72 hodín, aktualizovaný dvakrát denne. Obsahuje otvorené dáta ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Kontrolný beh ICON-CH1-EPS od MeteoSwiss: konvekciu umožňujúci model nad Alpami s rozlíšením 1 km bežiaci až 33 hodín, aktualizovaný každé tri hodiny.",
  "common.forecastModelDescription_ICON_CH2": "Kontrolný beh ICON-CH2-EPS od MeteoSwiss: konvekciu umožňujúci model nad Alpami — Švajčiarsko a okolitý alpský región — s rozlíšením 2,1 km bežiaci až 120 hodín, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_ICON_DE": "Vysokorozlišovací model DWD umožňujúci riešenie konvekcie nad Nemeckom a susednými krajinami s rozlíšením 2,2 km. Krátkodobé predpovede aktualizované dvakrát denne. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Európske hniezdo modelu ICON DWD s rozlíšením 7 km pokrývajúce Európu a severný Atlantik. Strednodobé predpovede aktualizované štyrikrát denne. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Otvorená služba predpovede počasia Nórskeho meteorologického ústavu, ktorá kombinuje severské modely s vysokým rozlíšením s údajmi ECMWF a poskytuje celosvetové predpovede až 10 dní dopredu.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Hniezdo AROME nad francúzskymi Antilami (Guadeloupe, Martinik) s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Hniezdo AROME nad Francúzskou Guyanou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Hniezdo AROME nad Novou Kaledóniou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Hniezdo AROME nad Francúzskou Polynéziou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Hniezdo AROME nad Réunionom a Mayotte s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_NAM_CONUS": "Severoamerický mezoskalárny model NOAA nad kontinentálnymi Spojenými štátmi s rozlíšením 5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Severoamerický mezoskalárny model NOAA pokrývajúci celú Severnú Ameriku s rozlíšením 32 km. Aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Vlajková predpoveď SmartMixin. Pre každú hodinu na vašom mieste vyberáme najlepší dostupný model — zvyčajne vysokorozlišovací regionálny model tam, kde existuje (AROME vo Francúzsku, ICON-D2 v Nemecku, HRRR v USA, ARPEGE Europe naprieč kontinentom…) a inde sa vraciame ku globálnemu modelu — potom zaplníme akékoľvek medzery zo susedných zdrojov. Výsledkom je jediná bezproblémová predpoveď pokrývajúca kdekoľvek na svete až 14 dní, automaticky aktualizovaná vždy, keď je niektorý zo základných modelov aktualizovaný.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Vlastná globálna predpoveď Weatherflow, ktorá kombinuje viacero numerických modelov počasia s pozorovaniami zo siete meteorologických staníc Tempest. Celosvetový 10-dňový horizont.",
  "common.forecastModelDetailTitle": "Predpovedný model",
  "common.forecastModelScopeGlobal": "Globálny",
  "common.forecastModelScopeGlobalDescription": "Tento model pokrýva celú planétu.",
  "common.forecastModelScopeRegional": "Regionálny",
  "common.forecastModelScopeRegionalDescription": "Tento model pokrýva iba určitý región.",
  "common.forecastModelSpecifications": "Špecifikácie",
  "common.forecastNoPinLocation": "Na toto miesto nedosiahne žiadny preferovaný model — rozhoduje „všade inde“.",
  "common.forecastNoPinStation": "Na túto stanicu nedosiahne žiadny preferovaný model — rozhoduje „všade inde“.",
  "common.forecastNoPreferredModels": "Zatiaľ nie sú nastavené žiadne preferované modely.",
  "common.forecastOverrideElsewhere": "Vaše predvoľby platia všade inde.",
  "common.forecastPickForLocation": "Alebo vyberte jeden pre toto miesto",
  "common.forecastPickForStation": "Alebo vyberte jeden pre túto stanicu",
  "common.forecastPinWinsLocation": "{model} — váš prvý preferovaný model, ktorý dosiahne na toto miesto.",
  "common.forecastPinWinsStation": "{model} — váš prvý preferovaný model, ktorý dosiahne na túto stanicu.",
  "common.forecastServedNowHere": "Práve teraz je to tu {model}",
  "common.forecastSetForLocation": "Nastavené pre toto miesto",
  "common.forecastSetForStation": "Nastavené pre túto stanicu",
  "common.forecastSettingsRowSub": "Preferované modely a čo platí všade inde",
  "common.forecastSheetTitle": "Model predpovede",
  "common.forecastSources": "Zdroje predpovedí",
  "common.forecastStopUsingHere": "Tu už nepoužívať",
  "common.forecastUseForLocation": "Použiť {model} pre toto miesto",
  "common.forecastUseForStation": "Použiť {model} pre túto stanicu",
  "common.forecastUsePreferred": "Použiť moje preferované modely",
  "common.freeAccount": "Bezplatný účet",
  "common.freeSubscription": "Bezplatné prémiové predplatné",
  "common.freeTrialForPeriod": "Bezplatná skúšobná verzia na {period} dní",
  "common.frequency": "Frekvencia",
  "common.full": "Plný",
  "common.fullscreen": "Celá obrazovka",
  "common.getStartedFree": "Začať Zadarmo",
  "common.getUnlimitedAccess": "Neobmedzený prístup k:",
  "common.good": "Dobrý",
  "common.hail": "Krúpy",
  "common.help": "Pomocník",
  "common.helpCategoryAccount": "Účet",
  "common.helpCategoryBilling": "Fakturácia",
  "common.helpCategoryForecast": "Predpovede",
  "common.helpCategoryGettingStarted": "Začíname",
  "common.helpCategoryProviders": "Poskytovatelia",
  "common.helpCategoryStations": "Stanice",
  "common.helpCategoryTroubleshooting": "Riešenie problémov",
  "common.helpCenter": "Centrum pomoci",
  "common.helpCenterDescription": "Nájdite odpovede na časté otázky a zistite, ako čo najlepšie využiť SmartMixin.",
  "common.hg": "Ochrana pred mrazom",
  "common.hidden": "Skryté",
  "common.hiddenSensors": "Skryté senzory",
  "common.hiddenStations": "Skryté stanice",
  "common.hiddenStationsDescription": "Stanicu môžete odblokovať klepnutím na ikonu oka vedľa nej.",
  "common.high": "Vysoký",
  "common.home": "Domov",
  "common.homeConnectService": "Vlastníte meteostanicu? Pripojte svoju službu",
  "common.homeInformation": "Domáce informácie",
  "common.homeIntroduction": "Začnite pripájať svoje externé účty a vychutnajte si funkcie SmartMixin.",
  "common.homeName": "Názov domova",
  "common.homeSubtitle": "Vaše počasie, všetko na jednom mieste",
  "common.horizon": "Horizont",
  "common.horizonValue": "až do {value} hodín",
  "common.hour": "Hodina",
  "common.iDontKnowYet": "Ešte neviem",
  "common.indoor": "Interiér",
  "common.lastRainEvent": "Posledné dažďové udalosti",
  "common.lastUpdate": "Posledná aktualizácia",
  "common.legendHeavy": "Silné",
  "common.legendLight": "Slabé",
  "common.legendLightningHelp": "Farba zobrazuje vek každého blesku za posledných {minutes} minút — najnovšie bielou, najstaršie tmavočervenou.",
  "common.legendNewest": "Najnovšie",
  "common.legendOldest": "Najstaršie",
  "common.legendStationsHelp": "Farba značky odráža hodnotu vybranej veličiny.",
  "common.lightningDataAttribution": "Údaje o bleskoch: Blitzortung.org",
  "common.lightningStrikes": "Údery bleskov",
  "common.lightningStrikesDescription": "Zobraziť údery bleskov v reálnom čase na mape",
  "common.linkToSection": "Odkaz na túto sekciu",
  "common.loading": "Načítava sa",
  "common.location": "Miesto",
  "common.locationAddedToFavorites": "Poloha pridaná do obľúbených položiek",
  "common.locationNotGranted": "Povolenie na umiestnenie nie je udelené. Umožnite prístup k vašej polohe v nastaveniach zariadenia.",
  "common.locationRemovedFromFavorites": "Poloha odstránená z obľúbených položiek",
  "common.locations": "Miesta",
  "common.low": "Nízke",
  "common.manage": "Spravovať",
  "common.manageAccount": "Spravovať účet",
  "common.manageMySubscription": "Spravovať moje predplatné",
  "common.manageSensors": "Správa senzorov",
  "common.manageSensorsDescription": "Presuňte položky pre zmenu poradia senzorov. Klepnite na ikonu oka pre zobrazenie alebo skrytie senzorov. Klepnite na názov pre jeho premenovanie.",
  "common.manualBoost": "Manuálne zvýšenie",
  "common.manualSetpointUntil": "Manuálna nastavená hodnota do",
  "common.mapLayers": "Vrstvy mapy",
  "common.mapLegend": "Legenda mapy",
  "common.maxFavoriteLocationsReached": "Môžete mať iba až 5 obľúbených miest. Odstráňte jeden a pridajte ďalší.",
  "common.maximum": "Maximum",
  "common.maxOverThePeriod": "Maximum za dané obdobie",
  "common.measureToDisplay": "Merania na zobrazenie",
  "common.medium": "Stredné",
  "common.meshSize": "Veľkosť mriežky",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min čítania",
  "common.modifyFavoriteStations": "Upraviť obľúbené stanice",
  "common.modifyFavoriteStationsDescription": "Môžete objednať svoje obľúbené stanice ich pretiahnutím. Môžete ich tiež odstrániť zo zoznamu.",
  "common.moduleType": "Typ modulu",
  "common.monthTotal": "Celkovo za mesiac",
  "common.more": "Viac",
  "common.moreInformation": "Viac informácií",
  "common.morning": "Ráno",
  "common.myLocation": "Moja poloha",
  "common.nearbyWeatherStations": "Blízke meteorologické stanice",
  "common.next": "Ďalší",
  "common.nextHours": "Hodinová predpoveď",
  "common.night": "Noc",
  "common.no": "Nie",
  "common.noAccountNeeded": "Bez nutnosti účtu",
  "common.noDataForThisPeriod": "Žiadne údaje za toto obdobie",
  "common.noLocationsFound": "Žiadne miesta nenájdené",
  "common.noNetatmoWeatherStationYet": "Ešte nemáte meteorologickú stanicu Netatmo.",
  "common.noOutdoorModule": "Pre túto stanicu nie je funkčný vonkajší modul.",
  "common.noSearchResults": "Vášmu vyhľadávaniu nezodpovedajú žiadne články",
  "common.noStationsFound": "Žiadne stanice nenájdené",
  "common.noThermostatYet": "Ešte nemáte termostat.",
  "common.notNow": "Nie teraz",
  "common.notPurchasedYet": "Zdá sa, že toto ešte nebolo zakúpené.",
  "common.now": "Teraz",
  "common.noWeatherStation": "Žiadna meteorologická stanica",
  "common.noWeatherStationYet": "Ešte nemáte meteorologickú stanicu.",
  "common.numberOfActiveWarnings": "{warning_count} aktívne varovania o počasí",
  "common.onThisPage": "Na tejto stránke",
  "common.openSettings": "Otvorené nastavenia",
  "common.orChooseMonthly": "Alebo zvoľte mesačne:",
  "common.outdatedModule": "Údaje tohto modulu sú neaktuálne.",
  "common.outdoor": "Exteriér",
  "common.outdoorTemperature": "Vonkajšia teplota",
  "common.pageNotFound": "Stránka Nenájdená",
  "common.pageNotFoundDescription": "Stránka, ktorú hľadáte, neexistuje alebo bola presunutá.",
  "common.passwordUpdated": "Heslo bolo úspešne aktualizované.",
  "common.personalWeatherIntelligence": "Vaša Osobná Meteorologická Inteligencia",
  "common.platformMobileApp": "Mobilná aplikácia",
  "common.platformMobileOnly": "Iba v mobilnej aplikácii",
  "common.platformWebApp": "Webová aplikácia",
  "common.platformWebOnly": "Iba vo webovej aplikácii",
  "common.popularArticles": "Obľúbené články",
  "common.premiumAccount": "Prémiový účet",
  "common.premiumDescription": "Prémiové predplatné odomkne mnoho ďalších funkcií, ako je pokročilá analýza počasia, porovnania máp, modely regionálnej predpovede a mnohé ďalšie.",
  "common.premiumFeatureAlerts": "Výstrahy Počasia",
  "common.premiumFeatureAnalysis": "Pokročilá Analýza Počasia",
  "common.premiumFeatureCharts": "Porovnanie Grafov",
  "common.premiumFeatureExport": "Export Dát",
  "common.premiumFeatureForecast": "Regionálne Predpovedné Modely",
  "common.premiumFeatureNotification": "Widget Stavového Riadku",
  "common.premiumFeatureTitle": "Prémiová Funkcia",
  "common.premiumFeatureWidgets": "Widgety domovskej obrazovky",
  "common.pressureSummary": "Tlak sumár",
  "common.previous": "Predchádzajúci",
  "common.previousHours": "Predchádzajúce hodiny",
  "common.profileUpdated": "Profil bol úspešne aktualizovaný.",
  "common.purchasedNetatmoPro": "V minulosti ste si zakúpili Netatmo Pro ({date}). Poskytuje vám prístup k podmnožine prémiových funkcií. Ak chcete mať prístup ku všetkým prémiovým funkciám, prihláste sa na odber jednej z nasledujúcich ponúk.",
  "common.radarDataAttribution": "Údaje z radaru: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Dážď",
  "common.rainEvents": "Dažďové udalosti",
  "common.rainfallMeasurement": "Meranie zrážok",
  "common.rainRadar": "Dažďový radar",
  "common.rainRadarDescription": "Zobrazte na mape prekrytie dažďového radaru",
  "common.rainSummary": "Dážď sumár",
  "common.range": "Rozsah",
  "common.recentLocations": "Posledný",
  "common.recentLocationsEmpty": "Tvoj nedávna história je prázdna.",
  "common.recentStations": "Nedávne stanice",
  "common.relatedArticles": "Súvisiace články",
  "common.relay": "Relé",
  "common.removeFromFavorites": "Odstrániť z obľúbených",
  "common.renameSensors": "Premenovať senzory",
  "common.resetZoom": "Obnoviť priblíženie",
  "common.restorePurchase": "Obnoviť nákup",
  "common.room": "Miestnosť",
  "common.rooms": "Miestnosti",
  "common.savingsPercent": "Ušetríte {percent}%",
  "common.searchArticles": "Hľadať články...",
  "common.searchForALocation": "Hľadať miesto...",
  "common.searchForLocation": "Vyhľadajte miesto",
  "common.searchForWeatherStation": "Vyhľadajte meteorologickú stanicu",
  "common.searchResults": "Výsledky vyhľadávania",
  "common.searchResultsEmpty": "Nezistili sa žiadne výsledky.",
  "common.searchResultsFound": "{count, plural, one {Nájdený # výsledok} few {Nájdené # výsledky} many {Nájdené # výsledku} other {Nájdených # výsledkov}}",
  "common.searchStationsDescription": "Zadajte mesto, adresu alebo názov miesta pre nájdenie meteorologických staníc v okolí.",
  "common.searchStationsHint": "Použite vyhľadávacie pole vyššie na objavenie meteorologických staníc kdekoľvek na svete.",
  "common.selectStationForComparison": "Vyberte stanicu na porovnanie",
  "common.selectWeatherForecastProvider": "Prosím, vyberte poskytovateľa počasia",
  "common.serialNumber": "Sériové číslo",
  "common.share": "Zdieľať",
  "common.shareOutdoorMeasures": "Zdieľajte svoje vonkajšie merania",
  "common.shareOutdoorMeasuresDescription": "Zapojte sa do komunity SmartMixin tým, že zviditeľníte svoje vonkajšie merania pre ostatných. Vnútorné merania nebudú nikdy zdieľané.",
  "common.shareYourWeather": "Zdieľajte počasie",
  "common.signalStrength": "Sila signálu",
  "common.skip": "Preskočiť",
  "common.smartThermostat": "Inteligentný termostat",
  "common.smartValve": "Inteligentný ventil",
  "common.snow": "Sneh",
  "common.start": "Štart",
  "common.startFreeTrial": "Začať Bezplatnú Skúšobnú Verziu",
  "common.startTime": "Čas spustenia",
  "common.station": "stanica",
  "common.stationAddedToFavorites": "Stanica bola pridaná medzi obľúbené",
  "common.stationComparison": "Porovnanie staníc",
  "common.stationComparisonDescription": "Porovnajte historické údaje o počasí s inou stanicou",
  "common.stationInformation": "Informácie o stanici",
  "common.stationName": "Názov stanice",
  "common.stationObservationsDescription": "Zobrazte najnovšie pozorovania z meteorologických staníc",
  "common.stationRemovedFromFavorites": "Stanica bola odstránená z obľúbených",
  "common.stations": "stanice",
  "common.stationsNear": "Stanice v okolí",
  "common.stationType": "Typ stanice",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Zastarané",
  "common.statusSyncing": "Synchronizácia",
  "common.stillNeedHelp": "Stále potrebujete pomoc?",
  "common.stillNeedHelpDescription": "Ak tento článok nezodpovedal vašu otázku, rád vám pomôžem osobne.",
  "common.subscribeNow": "Predplatiť teraz - bez skúšobnej doby",
  "common.sumOverThePeriod": "Kumulované za dané obdobie",
  "common.switchToPremium": "Prejdite na SmartMixin Premium",
  "common.temperatureShort": "Tepl.",
  "common.temperatureSummary": "Teplota sumár",
  "common.thankYouForFeedback": "Ďakujeme za vašu spätnú väzbu!",
  "common.thenPrice": "potom {price}",
  "common.timeSelection": "Časový výber",
  "common.timezone": "Časové pásmo",
  "common.totalDuration": "Dĺžka celkovo",
  "common.tryAnotherLocation": "Nepodarilo sa nám nájsť žiadne meteorologické stanice v blízkosti tohto miesta. Skúste hľadať v inej oblasti.",
  "common.unknown": "Neznámy",
  "common.untilChanged": "Až do zmeny",
  "common.untilTime": "Do {time}",
  "common.updateAvailable": "K dispozícii je aktualizácia",
  "common.updateAvailableOpenAppStore": "Klepnutím otvoríte App Store",
  "common.updateAvailableOpenGooglePlay": "Klepnutím otvoríte Google Play",
  "common.updateAvailableVersion": "K dispozícii je aktualizácia: v{version}",
  "common.upgrade": "Aktualizácia",
  "common.upgradeRequiredAndroid": "Vyžaduje sa aktualizácia. Navštívte Google Play a aktualizujte aplikáciu na najnovšiu verziu",
  "common.upgradeRequiredIos": "Vyžaduje sa aktualizácia. Navštívte App Store a aktualizujte aplikáciu na najnovšiu verziu",
  "common.validate": "Overiť",
  "common.validEmail": "Vyžaduje sa platná e-mailová adresa.",
  "common.very_low": "Veľmi nízke",
  "common.viewAsList": "Zoznam",
  "common.viewAsPeriods": "Časti dňa",
  "common.visitNetatmoWebsite": "Navštívte webovú stránku Netatmo",
  "common.wasArticleHelpful": "Bol tento článok užitočný?",
  "common.weatherCondition": "Meteorologické podmienky",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain je dodatočný zdroj údajov poskytovaný prostredníctvom systému Tempest Weather System, ktorý využíva technológiu Nearcast. Údaje NC Rain sú odhadom priemernej akumulácie zrážok okolo vášho Tempestu na úrovni susedstva",
  "common.weatherForecastModels": "Modely predpovedí počasia",
  "common.weatherIntelligencePlatform": "Platforma Meteorologickej Inteligencie",
  "common.weatherMap": "Mapa počasia",
  "common.weatherMapMetaDescription": "SmartMixin ponúka interaktívne mapy počasia a radaru pre poveternostné podmienky po celom svete.",
  "common.weatherObservations": "Pozorovania počasia",
  "common.weatherStation": "Meteorologická stanica",
  "common.weatherStations": "Meteorologické stanice",
  "common.welcome": "Vitajte v SmartMixin!",
  "common.whenBackHome": "Kedy sa vrátite domov?",
  "common.wifiStrength": "Sila WiFi signálu",
  "common.wind": "Vietor",
  "common.windMeasurement": "Meranie vetra",
  "common.windSpeed": "Rýchlosť vetra",
  "common.windSummary": "Vietor sumár",
  "common.yearToDate": "Rok do dňa",
  "common.yes": "Áno",
  "common.zoomImage": "Priblížiť obrázok",
  "forecastMaps.addColor": "Pridať farbu",
  "forecastMaps.addLayer": "Pridať vrstvu",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Späť na mapy",
  "forecastMaps.browseMaps": "Prechádzať mapy",
  "forecastMaps.build": "Vygenerovať",
  "forecastMaps.buildCompleted": "Generovanie dokončené",
  "forecastMaps.builderMetaDescription": "Zostavte si vlastné predpovedné mapy z vrstiev meteorologických modelov.",
  "forecastMaps.builderTitle": "Tvorca máp",
  "forecastMaps.buildFailed": "Generovanie zlyhalo. Skúste to znova.",
  "forecastMaps.buildNotPossible": "Túto mapu zatiaľ nemožno vygenerovať — nie sú k dispozícii žiadne predpovedné dáta.",
  "forecastMaps.buildProgress": "Vykresľovanie… {completed}/{total} krokov",
  "forecastMaps.buildStarting": "Spúšťanie generovania…",
  "forecastMaps.byModel": "Podľa modelu",
  "forecastMaps.byZone": "Podľa zóny",
  "forecastMaps.colormap": "Farebná škála",
  "forecastMaps.colormapCustom": "Vlastné farby",
  "forecastMaps.colormapGroupDomain": "Meteorologické predvoľby",
  "forecastMaps.colormapGroupMatplotlib": "Vedecké predvoľby",
  "forecastMaps.colorScale": "Farebná škála",
  "forecastMaps.comingSoon": "Toto zobrazenie bude čoskoro k dispozícii.",
  "forecastMaps.contourLevels": "Úrovne izolínií",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francúzsko",
  "forecastMaps.countryGermany": "Nemecko",
  "forecastMaps.countryItaly": "Taliansko",
  "forecastMaps.countryScandinavia": "Škandinávia",
  "forecastMaps.countrySpain": "Španielsko",
  "forecastMaps.countrySwitzerland": "Švajčiarsko",
  "forecastMaps.countryUnitedStates": "Spojené štáty",
  "forecastMaps.customColormapMinColors": "Vlastná farebná škála vyžaduje aspoň dve farby",
  "forecastMaps.customExtent": "Vlastný výrez",
  "forecastMaps.deleteMap": "Vymazať mapu",
  "forecastMaps.deleteMapBody": "„{name}“ a jej vykreslené behy budú natrvalo vymazané.",
  "forecastMaps.deleteMapTitle": "Vymazať túto mapu?",
  "forecastMaps.displayName": "Zobrazovaný názov",
  "forecastMaps.downloadMp4": "Stiahnuť MP4",
  "forecastMaps.downscaling": "Faktor riedenia veterných zástaviek",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nakresliť oblasť",
  "forecastMaps.east": "Východ",
  "forecastMaps.editMap": "Upraviť mapu",
  "forecastMaps.exportBuilding": "Pripravuje sa video…",
  "forecastMaps.exportError": "Export videa zlyhal. Skúste to znova.",
  "forecastMaps.exportMp4": "Exportovať MP4",
  "forecastMaps.exportNotReady": "Video ešte nie je pripravené. Skúste to neskôr.",
  "forecastMaps.extentDrawHint": "Ťahaním po mape nakreslite oblasť",
  "forecastMaps.extentInvalid": "Západ musí byť menší než východ a juh menší než sever",
  "forecastMaps.extentPanZoomHint": "Posúvajte a približujte, kým oblasť nevyplní rámec",
  "forecastMaps.flipbookView": "Animácia",
  "forecastMaps.forecastModel": "Predpovedný model",
  "forecastMaps.forkAndEdit": "Duplikovať a upraviť",
  "forecastMaps.height": "Výška (palce)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Neplatná farba — použite #RRGGBB",
  "forecastMaps.layers": "Vrstvy",
  "forecastMaps.layerTypeBarbs": "Veterné zástavky",
  "forecastMaps.layerTypeContour": "Izolínie",
  "forecastMaps.layerTypeFilledContour": "Vyplnené izolínie",
  "forecastMaps.layerTypeMagnitude": "Veľkosť",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorové pole",
  "forecastMaps.leave": "Odísť",
  "forecastMaps.levelsCount": "Počet",
  "forecastMaps.levelsInvalid": "Neplatné úrovne izolínií",
  "forecastMaps.levelsModeArange": "Pevný krok",
  "forecastMaps.levelsModeExplicit": "Explicitné hodnoty",
  "forecastMaps.levelsModeLinspace": "Rovnomerne rozložené (počet)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Hodnoty",
  "forecastMaps.levelsValuesHint": "Oddelené čiarkami, vzostupne",
  "forecastMaps.localTimeHint": "Zobrazené v miestnom čase",
  "forecastMaps.map": "Mapa",
  "forecastMaps.mapDescription": "Popis",
  "forecastMaps.mapName": "Názov mapy",
  "forecastMaps.mapNameRequired": "Zadajte názov",
  "forecastMaps.mapSettings": "Nastavenia mapy",
  "forecastMaps.mapView": "Interaktívna mapa",
  "forecastMaps.maxLayersReached": "Táto mapa dosiahla maximum {max} vrstiev.",
  "forecastMaps.maxValue": "Maximálna hodnota",
  "forecastMaps.memoryBudgetExceeded": "Rozlíšenie prekračuje limit vykresľovania — znížte DPI alebo výšku",
  "forecastMaps.memoryBudgetUsage": "Limit vykresľovania: {percent}%",
  "forecastMaps.metaDescription": "Animované predpovedné mapy vytvorené z behov meteorologických modelov.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Vyberte veličinu",
  "forecastMaps.metricUnavailable": "Pre tento model nie je k dispozícii",
  "forecastMaps.minBelowMax": "Minimum musí byť menšie než maximum",
  "forecastMaps.minMaxRequired": "Minimálne a maximálne hodnoty sú pre tento typ vrstvy povinné",
  "forecastMaps.minValue": "Minimálna hodnota",
  "forecastMaps.modelNoRun": "Zatiaľ žiadny dokončený beh",
  "forecastMaps.moveLayerDown": "Posunúť nadol",
  "forecastMaps.moveLayerUp": "Posunúť nahor",
  "forecastMaps.myMaps": "Moje mapy",
  "forecastMaps.nanClipToMin": "Obmedziť na minimum",
  "forecastMaps.nanMask": "Maskovať",
  "forecastMaps.nanPolicy": "Chýbajúce dáta",
  "forecastMaps.nanSkip": "Preskočiť",
  "forecastMaps.newMap": "Nová mapa",
  "forecastMaps.noCompletedRun": "Táto mapa zatiaľ nebola vytvorená. Skúste to prosím neskôr.",
  "forecastMaps.noLayers": "Zatiaľ žiadne vrstvy. Začnite pridaním vrstvy.",
  "forecastMaps.noMapsAvailable": "Zatiaľ nie sú k dispozícii žiadne predpovedné mapy.",
  "forecastMaps.north": "Sever",
  "forecastMaps.opacity": "Priehľadnosť",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pozastaviť",
  "forecastMaps.play": "Prehrať",
  "forecastMaps.pointValueError": "Predpoveď pre tento bod sa nepodarilo načítať.",
  "forecastMaps.pointValueLoading": "Načítava sa predpoveď…",
  "forecastMaps.pointValueUnavailable": "Pre tento čas nie sú k dispozícii žiadne údaje.",
  "forecastMaps.presets": "Predvoľby",
  "forecastMaps.preview": "Náhľad",
  "forecastMaps.previewEmptyHint": "Na vykreslenie náhľadu nastavte aspoň jednu platnú vrstvu.",
  "forecastMaps.previewFailed": "Náhľad zlyhal",
  "forecastMaps.previewHour": "Hodina predpovede",
  "forecastMaps.previewRendering": "Vykresľovanie náhľadu…",
  "forecastMaps.projection": "Projekcia",
  "forecastMaps.projectionLambertConformal": "Lambertova konformná",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografická",
  "forecastMaps.regionEurope": "Európa",
  "forecastMaps.regionNorthAmerica": "Severná Amerika",
  "forecastMaps.removeColor": "Odstrániť farbu",
  "forecastMaps.removeLayer": "Odstrániť vrstvu",
  "forecastMaps.retry": "Skúsiť znova",
  "forecastMaps.run": "Beh: {run}",
  "forecastMaps.save": "Uložiť",
  "forecastMaps.selectExtentOnMap": "Vybrať oblasť na mape",
  "forecastMaps.south": "Juh",
  "forecastMaps.title": "Predpovedné mapy",
  "forecastMaps.uMetric": "Zložka U",
  "forecastMaps.unitConversion": "Prevod jednotiek",
  "forecastMaps.unitNone": "Žiadny",
  "forecastMaps.unsavedChangesBody": "Máte neuložené zmeny. Odísť a zahodiť ich?",
  "forecastMaps.unsavedChangesTitle": "Neuložené zmeny",
  "forecastMaps.useCurrentView": "Použiť aktuálne zobrazenie",
  "forecastMaps.useModelDomain": "Vypnuté: použije sa celá oblasť modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličiny U a V sa musia líšiť",
  "forecastMaps.validTime": "Platnosť: {time}",
  "forecastMaps.valueBetween": "Musí byť medzi {min} a {max}",
  "forecastMaps.variable": "Veličina",
  "forecastMaps.viewMap": "Zobraziť mapu",
  "forecastMaps.vMetric": "Zložka V",
  "forecastMaps.west": "Západ",
  "forecastMaps.windAnimation": "Animácia vetra",
  "intro.locationDescription": "Povoľte prístup k polohe, aby ste získali presné predpovede prispôsobené vašej presnej oblasti — žiadne univerzálne predpovede.",
  "intro.locationTitle": "Predpovede vytvorené pre vás",
  "intro.notificationDescription": "Zapnite upozornenia, aby ste dostávali včasné upozornenia na zmeny počasia, ktoré sú pre vás dôležité — dážď, sneh alebo extrémne podmienky, práve keď to potrebujete vedieť.",
  "intro.notificationsTitle": "Nikdy nezmeškajte zmenu počasia",
  "intro.readyDescription": "Užite si presné predpovede, aktuálne meteorologické informácie a dáta zo staníc po celom svete — všetko v jednej výkonej aplikácii.",
  "intro.readyTitle": "Ste pripravení!",
  "intro.welcomeDescription": "Získajte hyperlokálne predpovede od popredných meteorologických agentúr — plus prístup k viac ako 40 000 meteorologickým staniciam po celom svete, aby ste videli reálne podmienky, minulé aj súčasné.",
  "intro.welcomeTitle": "Vaše počasie, prepracované",
  "landing.alerts": "Upozornenia",
  "landing.alertsDescription": "Vytvorte si vlastné upozornenia a získajte upozornenia hneď, ako sa spustia.",
  "landing.featureAlertsDescription": "Nastavte si vlastné upozornenia pre podmienky, ktoré vás zaujímajú—teplota, vietor, zrážky a ďalšie.",
  "landing.featureAlertsTitle": "Inteligentné upozornenia",
  "landing.featureAnalyticsDescription": "Ponorte sa do svojich dát pomocou interaktívnych grafov, porovnaní vedľa seba a analýzy trendov presahujúcej základné metriky.",
  "landing.featureAnalyticsTitle": "Výkonná analytika",
  "landing.featureExportDescription": "Stiahnite si svoje dáta vo formáte CSV pre analýzu v Exceli, integráciu s inými systémami alebo zálohu.",
  "landing.featureExportTitle": "Export kamkoľvek",
  "landing.featureForecastDescription": "Porovnajte predpovede z viac ako 10 meteorologických modelov vrátane GFS, ECMWF, ICON a ďalších, aby ste videli, ktorý funguje najlepšie pre vašu lokalitu.",
  "landing.featureForecastTitle": "Porovnanie predpovedí",
  "landing.featureHistoryDescription": "Prístup k historickým dátam v hodinovej, dennej a mesačnej mierke. Export do CSV pre výskum alebo osobné archívy.",
  "landing.featureHistoryTitle": "Bohatá história",
  "landing.featureMultiBrandDescription": "Pripojte stanice od Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow a ďalších—všetko v jednom dashboarde.",
  "landing.featureMultiBrandTitle": "Podpora viacerých značiek",
  "landing.featuresSubtitle": "Navrhnuté pre nadšencov do počasia, ktorí vyžadujú viac ako základnú aplikáciu meteorologickej stanice.",
  "landing.featuresTitle": "Všetko, čo potrebujete na analýzu počasia",
  "landing.finalCtaButton": "Vytvoriť účet zadarmo",
  "landing.finalCtaSubtitle": "Pripojte sa k tisícom nadšencov do počasia, ktorí dôverujú SmartMixinu so svojimi meteorologickými dátami.",
  "landing.finalCtaTitle": "Pripravení vylepšiť svoje počasie?",
  "landing.forecastDescription": "Získajte prístup k niektorým z najlepších modelov predpovedí počasia a porovnajte ich, aby ste získali vlastnú predstavu o počasí.",
  "landing.forecasts": "Predpovede",
  "landing.heroCta": "Začať zadarmo",
  "landing.heroDescription": "Spojte viacero meteorologických staníc ľubovoľnej značky, porovnávajte predpovedné modely a analyzujte svoje dáta pomocou podrobných grafov a exportov.",
  "landing.heroSecondaryCta": "Zobraziť funkcie",
  "landing.heroTagline": "Pre nadšencov do počasia",
  "landing.heroTitle": "Všetky meteorologické dáta. Jedna platforma.",
  "landing.pricingFeatureAdvancedMetrics": "Pokročilé metriky",
  "landing.pricingFeatureAlerts": "Vlastné upozornenia",
  "landing.pricingFeatureExport": "Export dát (CSV)",
  "landing.pricingFeatureForecastComparison": "Porovnanie predpovedí",
  "landing.pricingFeatureForecasts": "Predpovedné modely",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Všetky modely (10+)",
  "landing.pricingFeatureReports": "Analýzy a správy",
  "landing.pricingFeatureStationComparison": "Porovnanie staníc",
  "landing.pricingFeatureWidgets": "Widgety na domovskej obrazovke",
  "landing.pricingFeatureYearOverYear": "Medziročná analýza",
  "landing.pricingFree": "Zadarmo",
  "landing.pricingFreeCta": "Začať",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najobľúbenejší",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Začať",
  "landing.pricingPremiumDescription": "Od 1,99 €/mesiac — predplaťte si na webe, App Store alebo Google Play",
  "landing.pricingSubtitle": "Začnite zadarmo, upgradujte keď potrebujete viac.",
  "landing.pricingTitle": "Jednoduchý, transparentný cenník",
  "landing.smartMixinDescription": "SmartMixin je aplikácia, ktorá poskytuje prístup k vašej meteorologickej stanici a viac ako 40 000 ďalším staniciam po celom svete. Pomáha vám vidieť a porozumieť údajom o počasí.",
  "landing.statBrands": "Podporované značky",
  "landing.statForecasts": "Predpovedných modelov",
  "landing.statStations": "Pripojených staníc",
  "landing.supportedDevices": "Podporované zariadenia",
  "landing.supportedDevicesDescription": "Okrem staníc Svetovej meteorologickej organizácie podporuje SmartMixin rastúci počet značiek meteorologických staníc.",
  "landing.supportedDevicesNote": "Plus viac ako 40 000 verejných staníc Svetovej meteorologickej organizácie",
  "landing.supportedDevicesSubtitle": "Pripojte meteorologické stanice popredných značiek a zobrazte všetky dáta na jednom mieste.",
  "landing.supportedDevicesTitle": "Funguje s vašimi stanicami",
  "landing.thermostatDescription": "Pripojte svoj termostat Netatmo a prepojte vzorce vykurovania s vonkajšími podmienkami.",
  "landing.thermostatManufacturers": "Výrobcovia termostatov sú tiež podporovaní, aby korelovali vykurovanie s vonkajšími podmienkami.",
  "landing.thermostatTitle": "Integrácia s inteligentnou domácnosťou",
  "landing.weatherAnalysis": "Analýza počasia",
  "landing.weatherAnalysisDescription": "SmartMix prichádza s množstvom vizualizácií údajov, ktoré vám umožňujú analyzovať údaje o počasí.",
  "landing.weatherAssistant": "Váš asistent počasia",
  "landing.weatherAssistantDescription": "Či už vás zaujímajú aktuálne, historické alebo predpovedané poveternostné podmienky, SmartMixin poskytuje množstvo informácií, kedykoľvek ich potrebujete.",
  "landing.weatherForecastModels": "Modely predpovedí počasia",
  "landing.weatherForecastModelsDescription": "SmartMixin poskytuje prístup k najpresnejším modelom predpovede počasia. Môžete ľahko porovnať ich prognózy a urobiť si vlastnú predstavu.",
  "landing.weatherMap": "Mapa počasia",
  "landing.weatherMapDescription": "Prehliadnite si mapu a predstavte si, aké je počasie kdekoľvek na svete.",
  "network.cancelError": "Požiadavka bola zrušená",
  "network.connectionError": "Server nie je k dispozícii",
  "network.networkError": "Sieť nie je k dispozícii",
  "network.serverError": "Niečo sa pokazilo...",
  "network.timeoutError": "Časový limit pripojenia vypršal",
  "network.unknownError": "Neznáma chyba",
  "providerHints.ambientWeatherApiKey": "Vytvorené v nastaveniach vášho účtu na ambientweather.net.",
  "providerHints.davisApiSecret": "Zobrazí sa iba raz pri vytvorení V2 API kľúča — uchovajte v bezpečí.",
  "providerHints.davisV2ApiKey": "Zo stránky V2 API kľúčov na weatherlink.com.",
  "providerHints.ecowittApi": "Zo stránky API vášho účtu Ecowitt.",
  "providerHints.ecowittApp": "Kľúč aplikácie, tiež z vášho účtu Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Použite e-mail a heslo vášho účtu My AcuRite — nie prihlásenie do SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail vášho účtu My AcuRite — nie vaše prihlásenie do SmartMixin.",
  "providerHints.myAcuritePassword": "Heslo vášho účtu My AcuRite.",
  "providerHints.weatherflowToken": "Osobný token z tempestwx.com → nastavenia → autorizácie údajov.",
  "providerHints.wundergroundEditKey": "Použiť iný kľúč",
  "providerHints.wundergroundKey": "Dlhý reťazec zo stránky API kľúčov vášho účtu Weather Underground — nie vaše heslo na wunderground.com.",
  "providerHints.wundergroundKeyExample": "napr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API kľúč overený",
  "providerHints.wundergroundKeyVerifying": "Overovanie kľúča…",
  "providerHints.wundergroundNoStationsNearby": "V okolí tejto lokality neboli nájdené žiadne stanice. Skúste zadať ID stanice priamo.",
  "providerHints.wundergroundStationId": "Akékoľvek ID stanice Weather Underground — vaše vlastné alebo verejná stanica vo vašom okolí.",
  "providerHints.wundergroundStationIdExample": "napr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Získajte svoj API kľúč Ambient Weather.",
  "providerIntro.davisStep2": "Získajte svoj V2 API kľúč a API tajomstvo Davis.",
  "providerIntro.ecowittStep2": "Získajte svoj API kľúč a kľúč aplikácie Ecowitt.",
  "providerIntro.getStarted": "Začať",
  "providerIntro.myAcuriteStep2": "Použite e-mail a heslo vášho existujúceho účtu My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.netatmoWeatherStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.signupBanner": "Takmer hotovo — vytvorte si bezplatný účet SmartMixin na pripojenie {provider}.",
  "providerIntro.step1": "Prihláste sa do svojho účtu SmartMixin (NIE do {provider}).",
  "providerIntro.step3EmailPassword": "Zadajte sem.",
  "providerIntro.step3KeyOrToken": "Vložte sem.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin vo vyskakovacom okne.",
  "providerIntro.step3Wunderground": "Vložte svoj API kľúč a potom vyberte stanicu v okolí alebo zadajte ľubovoľné ID stanice.",
  "providerIntro.title": "Pripojiť {provider}",
  "providerIntro.weatherflowStep2": "Získajte svoj osobný Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemáte stanicu? Prehliadajte verejné",
  "providerIntro.wundergroundFindNearby": "Nájsť stanice v okolí",
  "providerIntro.wundergroundOrEnterId": "Alebo zadať ID stanice",
  "providerIntro.wundergroundStep2": "Získajte svoj API kľúč Weather Underground. Potom budete môcť pripojiť akúkoľvek stanicu — vlastnú alebo verejnú.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Analýzy",
  "reports.annualCumulativeRainfallComparison": "Ročné kumulatívne porovnanie zrážok",
  "reports.annualHeatingDurationComparison": "Porovnanie doby vykurovania za rok",
  "reports.annualHeatingEfficiency": "Ročná efektivita vykurovania",
  "reports.annualIndoorComparison": "Ročné porovnanie - interiér",
  "reports.annualIndoorReport": "Výročná správa - interiér",
  "reports.annualOutdoorComparison": "Ročné porovnanie - exteriér",
  "reports.annualOutdoorReport": "Výročná správa - exteriér",
  "reports.annualReport": "Výročná správa",
  "reports.annualSolarReport": "Výročná solárna správa",
  "reports.annualWaterBalance": "Ročná vodná bilancia",
  "reports.annualWaterBalanceCarryOver": "Preniesť z predchádzajúceho roka",
  "reports.annualWaterBalanceDescription": "Vodná bilancia (zjednodušená verzia, používa sa len dážď a evapotranspirácia) pomáha riadiť zásobovanie vodou",
  "reports.avgHumidity": "Priemerná vlhkosť",
  "reports.avgMaxTemperature": "Priemerná T°max",
  "reports.avgMetric": "Priemer – {metric}",
  "reports.avgMinTemperature": "Priemerná T°min",
  "reports.avgPressure": "Priemerný tlak",
  "reports.avgTemperature": "Priemerná teplota",
  "reports.climateNormalPeriodOfRecord": "Obdobie merania ({years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}})",
  "reports.climateNormals": "Klimatické normály",
  "reports.climateNormalStandardLabel": "Štandardný normál ({period})",
  "reports.climateTrendPerDecade": "Trend teploty: {value} za desaťročie počas {years, plural, one {# roka} few {# rokov} many {# rokov} other {# rokov}}",
  "reports.coldestMonthRanking": "Najchladnejší {month} v histórii meraní",
  "reports.comfortable": "Komfortné (45 % {lessThan} vlhkosť ≤ 60 %)",
  "reports.cumulativeRainfall": "Kumulatívne zrážky",
  "reports.cumulativeRainfallDescription": "Sledujte celkové zrážky nahromadené za zvolené obdobie.",
  "reports.dailyMaxRainfall": "Max. denné zrážky",
  "reports.dataExport": "Export údajov",
  "reports.dataExportXlsxFormatDescription": "Exportujte všetky údaje vašej stanice vo formáte Excel (*.xlsx). Po kliknutí na tlačidlo vám po niekoľkých minútach príde email so spracovanými údajmi.",
  "reports.daysOfData": "{days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}} údajov",
  "reports.daysWithFrost": "Mrazivé dni",
  "reports.daysWithHeavyRain": "Dni s výdatným dažďom (≥ {threshold})",
  "reports.daysWithoutThaw": "Dni bez odmäku",
  "reports.daysWithStrongFrost": "Dni so silným mrazom",
  "reports.emailSent": "E-mail bol odoslaný do vašej poštovej schránky",
  "reports.frostDays": "Mrazové dni",
  "reports.grasslandTemperatureSum": "Súčet teploty trávnatých plôch",
  "reports.grasslandTemperatureSumDescription": "Ak sa na jar prekročí súčet {threshold}, dosiahol sa udržateľný začiatok vegetácie (funguje v Európe)",
  "reports.growingDegreeDays": "Rastové stupňodni",
  "reports.highPressure": "Tlaková výš (priemerný tlak ≥ 1013 mbar)",
  "reports.iceDays": "Ľadové dni",
  "reports.indoorReport": "Správa o interiéri",
  "reports.keyFacts": "Kľúčové fakty",
  "reports.longestDrySpell": "Najdlhšie suché obdobie",
  "reports.longestRunOfRainyDays": "Najdlhší priebeh daždivých dní",
  "reports.longestRunWithoutRun": "Najdlhší priebeh dní bez dažďa",
  "reports.longestWetSpell": "Najdlhšie daždivé obdobie",
  "reports.lowPressure": "Tlaková níž (priemerný tlak < 1013 mbar)",
  "reports.maxHumidity": "Maximálna vlhkosť",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Maximálny tlak",
  "reports.maxPressureMagnitude24h": "Maximálna magnitúda (/24H)",
  "reports.maxTemperature": "Maximálna teplota",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximálna magnitúda (/24H)",
  "reports.minHumidity": "Minimálna vlhkosť",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimálny tlak",
  "reports.minPressureMagnitude24h": "Minimálna magnitúda (/24H)",
  "reports.minTemperature": "Minimálna teplota",
  "reports.minTempMagnitude24h": "Minimálna magnitúda (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ešte # deň} few {Ešte # dni} many {Ešte # dňa} other {Ešte # dní}} tento mesiac",
  "reports.monthlyAverageCountdownDetail": "Potom sa zobrazí priemer tohto mesiaca a jeho poradie.",
  "reports.monthlyAverageRule": "Mesačné priemery a poradia sa zobrazia, keď kalendárny mesiac má zaznamenaných {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}.",
  "reports.monthlyHeatingEfficiency": "Mesačná efektivita vykurovania",
  "reports.monthlyIndoorReport": "Mesačná správa interiér",
  "reports.monthlyOutdoorReport": "Mesačná správa exteriér",
  "reports.monthlyReport": "Mesačná správa",
  "reports.monthlySolarReport": "Mesačná solárna správa",
  "reports.monthlyWindReport": "Mesačná správa o vetre",
  "reports.monthsOfData": "{months, plural, one {# mesiac} few {# mesiace} many {# mesiaca} other {# mesiacov}} údajov",
  "reports.numberOfDays": "Počet dní",
  "reports.onThisDayInHistory": "V tento deň v histórii",
  "reports.outdoorReport": "Správa o exteriéri",
  "reports.overviewSection": "Prehľad",
  "reports.rainfall": "Zrážky",
  "reports.rainyDays": "Daždivé dni",
  "reports.recordDailyRain": "Najdaždivejší deň",
  "reports.recordHigh": "Rekordné maximum",
  "reports.recordLow": "Rekordné minimum",
  "reports.recordsAndClimatology": "Rekordy a klíma",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Najsilnejší náraz vetra",
  "reports.relativelyWet": "Nadmerne vlhké (60 % < Vlhkosť ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# správa} few {# správy} many {# správ} other {# správ}}",
  "reports.sendEmail": "Odoslať email",
  "reports.summerDays": "Letné dni",
  "reports.tooDry": "Príliš suché (Vlhkosť ≤ 45%)",
  "reports.tooWet": "Príliš vlhké (Vlhkosť > 80 %)",
  "reports.tropicalNights": "Tropické noci",
  "reports.unlockPremiumSubtitle": "Súčasť SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odomknite {count, plural, one {# prémiovú funkciu} few {# prémiové funkcie} many {# prémiových funkcií} other {# prémiových funkcií}}",
  "reports.warmestMonthRanking": "Najteplejší {month} v histórii meraní",
  "reports.waterBalance": "Vodná bilancia",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}} údajov",
  "reports.yearToDateTemperatureComparison": "Porovnanie teplôt od začiatku roka",
  "sensors.aqiByChannel": "AQI podľa kanálu",
  "sensors.bgtSensors": "Čierna guľa a WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Porovnať AQI",
  "sensors.compareHumidity": "Porovnať vlhkosť",
  "sensors.compareMoisture": "Porovnať vlhkosť pôdy",
  "sensors.comparePm25": "Porovnať PM2.5",
  "sensors.compareTemperatures": "Porovnať teploty",
  "sensors.depthByChannel": "Hĺbka podľa kanála",
  "sensors.heatStressExtreme": "Extrémny tepelný stres",
  "sensors.heatStressModerate": "Mierny tepelný stres",
  "sensors.heatStressNone": "Žiadny tepelný stres",
  "sensors.heatStressStrong": "Silný tepelný stres",
  "sensors.heatStressVeryStrong": "Veľmi silný tepelný stres",
  "sensors.humidityByChannel": "Vlhkosť podľa kanálu",
  "sensors.indoorAirQualityPm": "PM2.5 a PM10 AQI",
  "sensors.indoorClimate": "Vnútorná klíma",
  "sensors.indoorCo2Levels": "Úrovne CO2",
  "sensors.indoorTemperatureAndHumidity": "Teplota a vlhkosť",
  "sensors.last24Hours": "24 hodín",
  "sensors.last30Days": "30 dní",
  "sensors.last7Days": "7 dní",
  "sensors.leafTemperatureByChannel": "Teplota listov podľa kanálu",
  "sensors.leafWetnessByChannel": "Vlhkosť listov podľa kanálu",
  "sensors.lightningSensor": "Blesk",
  "sensors.moistureByChannel": "Vlhkosť pôdy podľa kanálu",
  "sensors.noDataAvailable": "Žiadne dáta nie sú k dispozícii",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 podľa kanálu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vyberte kanál",
  "sensors.sensorDetailDescription": "Zobrazenie historických údajov a trendov pre kanály senzora.",
  "sensors.sensorHistory": "História senzora",
  "sensors.soilConductivityByChannel": "Vodivosť podľa kanálu",
  "sensors.soilTemperatureByChannel": "Teplota pôdy podľa kanálu",
  "sensors.strikesToday": "Údery dnes",
  "sensors.temperatureByChannel": "Teplota podľa kanálu",
  "sensors.viewChart": "Zobraziť graf",
  "settings.about": "O aplikácii",
  "settings.aboutDescription": "Licenčná zmluva, zásady ochrany súkromia",
  "settings.account": "Účet",
  "settings.accountDescription": "Profil, zmena hesla",
  "settings.accountIntro": "Údaje týkajúce sa vášho účtu:",
  "settings.accountOnHoldTitle": "Účet pozastavený",
  "settings.accountSection": "Účet",
  "settings.addForecastModel": "Pridať model",
  "settings.appearance": "Vzhľad",
  "settings.appearanceDescription": "Motív a možnosti zobrazenia",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabsky",
  "settings.atYourStations": "Dostupné na vašich staniciach",
  "settings.availableServices": "Dostupné",
  "settings.bulgarian": "bulharčina",
  "settings.cannotDisconnectLastAccount": "Nie je možné odpojiť jedinú metódu prihlásenia. Najprv pridajte inú metódu prihlásenia.",
  "settings.catalan": "katalánčina",
  "settings.changeEmail": "Zmeniť e-mail",
  "settings.changePassword": "Zmeniť heslo",
  "settings.chartGestures": "Gestá na grafoch",
  "settings.chartGesturesDescription": "Potiahnutím po grafoch sa zmení časové obdobie, stiahnutím grafov sa zmení časový rozsah",
  "settings.choiceCount": "{count, plural, one {Dostupný: #} few {Dostupné: #} many {Dostupných: #} other {Dostupných: #}}",
  "settings.connect": "Pripojiť",
  "settings.connected": "Pripojené",
  "settings.connectedAccounts": "Prepojené účty",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Pripojené",
  "settings.connectedSince": "Pripojené od {date}",
  "settings.connectionSection": "Pripojenie",
  "settings.connectionSuccess": "Účet {provider} úspešne pripojený",
  "settings.contactUs": "Kontaktujte nás",
  "settings.contactUsDescription": "Získajte pomoc alebo pošlite spätnú väzbu",
  "settings.coverageLoading": "Zisťujeme, ktoré z vašich staníc každý model pokrýva…",
  "settings.croatian": "chorvátsky",
  "settings.currentPassword": "Aktuálne heslo",
  "settings.czech": "česky",
  "settings.dailyDetailByPeriods": "Denné podrobnosti podľa častí dňa",
  "settings.dailyDetailByPeriodsDescription": "Zoskupí 24 hodín do noci, rána, popoludnia a večera — rovnaké rozdelenie, aké používa denný súhrn.",
  "settings.dangerZone": "Riziková zóna",
  "settings.danish": "dánsky",
  "settings.dark": "Tmavá téma",
  "settings.dataDisplay": "Zobrazenie údajov",
  "settings.dateAndTime": "Dátum a čas",
  "settings.disconnect": "Odpojiť",
  "settings.disconnectConfirmation": "Naozaj chcete odpojiť svoj účet {provider}?",
  "settings.disconnectionSuccess": "Účet {provider} úspešne odpojený",
  "settings.disconnectProviderDescription": "Zastaví synchronizáciu. Vaša história zostane zachovaná.",
  "settings.donateButton": "Prispieť darom",
  "settings.donateDescription": "SmartMixin vyvíja malý tím. Ak je pre vás užitočný, môžete podporiť jeho vývoj jednorazovým darom v ľubovoľnej výške. Je to dar — nemení váš plán ani neodomyká žiadne funkcie.",
  "settings.donateSuccessBody": "Váš dar pomáha udržať SmartMixin v prevádzke a zlepšovať ho. Veľmi si to vážime.",
  "settings.donateSuccessTitle": "Ďakujeme za vašu podporu!",
  "settings.donateTitle": "Podporte SmartMixin",
  "settings.dragToReorder": "Presunutím zmeníte poradie",
  "settings.dutch": "holandsky",
  "settings.emailChange": "Zmeniť e-mailovú adresu",
  "settings.emailChangeConfirmation": "Potvrdenie zmeny e-mailu",
  "settings.emailChangeFailure": "Odkaz na zmenu e-mailu je neplatný alebo vypršal.",
  "settings.emailChangeSuccess": "Váš e-mail bol úspešne zmenený na {newEmail}.",
  "settings.emailChangeVerificationSent": "Na vašu novú e-mailovú adresu bol odoslaný overovací e-mail. Skontrolujte svoju doručenú poštu a kliknite na odkaz na potvrdenie zmeny.",
  "settings.english": "anglicky",
  "settings.everywhereElse": "Všade inde",
  "settings.everywhereElseFoot": "Použije sa na každej stanici, kam vaše preferované modely nedosiahnu.",
  "settings.everywhereElsePick": "Vyberte jeden",
  "settings.fallbackBlend": "Zmes SmartMixin",
  "settings.fallbackBlendSub": "Kombinuje viacero modelov, každý tam, kde je najsilnejší.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES všade, kam dosiahne.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "Globálny model NOAA. To, čo dnes používa každý účet.",
  "settings.fallbackResolution": "Najvyššie rozlíšenie",
  "settings.fallbackResolutionSub": "Najjemnejšia sieť dostupná na každej stanici.",
  "settings.forecastModels": "Modely predpovede",
  "settings.freeBannerBody": "Bezplatné účty dostávajú všade GFS — preferované modely aj „všade inde“ začnú fungovať vo chvíli, keď si predplatíte.",
  "settings.freeBannerTitle": "Predvoľby platia s Premium",
  "settings.french": "francúzsky",
  "settings.german": "nemecky",
  "settings.gestures": "Gestá",
  "settings.greek": "grécky",
  "settings.helpCenter": "Centrum pomoci",
  "settings.helpCenterDescription": "Často kladené otázky a návody",
  "settings.hungarian": "maďarsky",
  "settings.integrationsSection": "Integrácie",
  "settings.italian": "taliansky",
  "settings.japanese": "japončina",
  "settings.korean": "kórejský",
  "settings.language": "Jazyk",
  "settings.languageDescription": "Preferovaný jazyk",
  "settings.light": "Svetlá téma",
  "settings.measurementUnits": "Merné jednotky",
  "settings.newEmailAddress": "Nová e-mailová adresa",
  "settings.newPassword": "Nové heslo",
  "settings.newPasswordAgain": "Nové heslo znova",
  "settings.norwegian": "nórsky",
  "settings.notConnected": "Nepripojené",
  "settings.notificationsSection": "Oznámenia",
  "settings.oldPassword": "Staré heslo",
  "settings.ongoingNotificationEnabled": "Povoliť trvalé oznámenie",
  "settings.ongoingNotificationMetrics": "Zobrazené metriky",
  "settings.ongoingNotificationPermissionRequired": "Vyžaduje sa povolenie na oznámenia",
  "settings.ongoingNotificationPreviewHint": "Náhľad — zapnite widget, aby sa zobrazil",
  "settings.ongoingNotificationStation": "Meteorologická stanica",
  "settings.ongoingNotificationStatusBar": "Stavový riadok",
  "settings.passwordChange": "Zmena hesla",
  "settings.passwordChangeDescription": "Udržujte svoj účet v bezpečí",
  "settings.pickerShowAll": "Zobraziť celý katalóg",
  "settings.pickerUnreachable": "{count, plural, one {# ďalší model nedosiahne} few {# ďalšie modely nedosiahnu} many {# ďalších modelov nedosiahne} other {# ďalších modelov nedosiahne}} na žiadnu z vašich staníc",
  "settings.pinInUse": "Používa sa",
  "settings.pinShadowed": "Nikdy sa nepoužije — model vyššie pokrýva všetky vaše stanice",
  "settings.pinSlots": "{used} z {max} · ťuknutím vyberte",
  "settings.pinSlotsFull": "Všetkých {max} miest je obsadených. Jedno odstráňte, aby ste mohli pridať ďalšie.",
  "settings.pinsUncoveredCount": "{used} z vašich {count, plural, one {# stanice} few {# staníc} many {# staníc} other {# staníc}}: nedosiahne na ne žiadny preferovaný model — rozhoduje „všade inde“.",
  "settings.pinsUncoveredNamed": "{stations}: nedosiahne {count, plural, one {na ňu} other {na ne}} žiadny preferovaný model — rozhoduje „všade inde“.",
  "settings.pinUnreachable": "Nikdy sa nepoužije — nedosiahne na žiadnu z vašich staníc",
  "settings.pinUsedAt": "Používa sa na {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Používa sa na vašej stanici} few {Používa sa na všetkých # staniciach} many {Používa sa na všetkých # staniciach} other {Používa sa na všetkých # staniciach}}",
  "settings.pinUsedAtSome": "Používa sa na {used} z {count, plural, one {# stanice} few {# staníc} many {# staníc} other {# staníc}}",
  "settings.polish": "poľsky",
  "settings.portuguese": "portugalsky",
  "settings.preferencesSection": "Predvoľby",
  "settings.preferredModels": "Preferované modely",
  "settings.preferredModelsAll": "Jeden zoznam, všetky stanice",
  "settings.preferredModelsOne": "Jeden zoznam, platí všade",
  "settings.premium": "Prémium",
  "settings.premiumActive": "Aktívne",
  "settings.premiumAnnualThenPrice": "Potom 9,99 €/rok",
  "settings.premiumAnnualTrialInfo": "Začnite s bezplatnou skúšobnou dobou na {days} dní",
  "settings.premiumCurrentPlan": "Aktuálny plán",
  "settings.premiumDescription": "Odomknite prémiové funkcie",
  "settings.premiumDownloadApp": "Stiahnite si aplikáciu na predplatné:",
  "settings.premiumExpiresOn": "Obnovuje sa {date}",
  "settings.premiumFreePlan": "Zadarmo",
  "settings.premiumInactive": "Bez predplatného",
  "settings.premiumManageWebSubscription": "Spravujte svoje predplatné, aktualizujte spôsob platby alebo zrušte.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Ročne — 9,99 €/rok",
  "settings.premiumSubscribedOn": "Predplatené cez {platform}",
  "settings.premiumSubscribeMonthly": "Mesačne — 1,99 €/mesiac",
  "settings.premiumSubscribeOnWeb": "Prihláste sa na odber a odomknite všetky prémiové funkcie.",
  "settings.premiumSubscriptionSuccess": "Vaše predplatné bolo aktivované! Užite si všetky prémiové funkcie.",
  "settings.premiumSubscriptionSuccessTitle": "Vitajte v Premium!",
  "settings.premiumWebappNotice": "Predplatné je možné zakúpiť iba prostredníctvom mobilnej aplikácie SmartMixin pre iOS alebo Android.",
  "settings.privacyPolicy": "Zásady ochrany osobných údajov",
  "settings.profile": "Profil",
  "settings.removePreferredModel": "Odstrániť {model} z preferovaných modelov",
  "settings.resetForecastPreference": "Obnoviť predvolené",
  "settings.resetForecastPreferenceHint": "Vymaže preferované modely a vráti predvolené nastavenie SmartMixin.",
  "settings.russian": "ruský",
  "settings.seePremium": "Zobraziť Premium",
  "settings.serbian": "srbsky",
  "settings.servedNowMany": "Práve teraz: GFS {count, plural, one {na vašej stanici} few {na všetkých # staniciach} many {na všetkých # staniciach} other {na všetkých # staniciach}}.",
  "settings.servedNowNone": "Práve teraz: GFS všade.",
  "settings.settings": "Nastavenia",
  "settings.signedInAs": "Prihlásený ako",
  "settings.slovak": "slovenský",
  "settings.smallDecimals": "Malé desatinné",
  "settings.smallDecimalsDescription": "Zobraziť desatinné číslice v menšej veľkosti",
  "settings.socialConnectionsIntro": "Prepojte svoje sociálne účty pre rýchle prihlásenie. Účty môžete kedykoľvek pripojiť alebo odpojiť.",
  "settings.spanish": "španielsky",
  "settings.statusBarWidget": "Widget stavového riadku",
  "settings.statusBarWidgetDescription": "Vždy viditeľné údaje o počasí",
  "settings.subscriptionSection": "Predplatné",
  "settings.supportSection": "Podpora",
  "settings.swedish": "švédsky",
  "settings.systemTheme": "Systémová téma",
  "settings.termsOfService": "Podmienky poskytovania služby",
  "settings.turkish": "turecký",
  "settings.ukrainian": "ukrajinčina",
  "settings.units": "Jednotky",
  "settings.unitsDescription": "Merné jednotky zobrazené v rámci aplikácie",
  "settings.update": "Aktualizácia",
  "settings.updateYourProfile": "Aktualizujte svoj profil",
  "settings.updateYourProfileDescription": "Meno a predvoľby zobrazenia",
  "settings.weatherServices": "Meteorologické služby",
  "settings.weatherServicesConnected": "{count, plural, =0 {Žiadne pripojené služby} one {# pripojená služba} few {# pripojené služby} many {# pripojených služieb} other {# pripojených služieb}}",
  "settings.weatherServicesDescription": "Pripojte Netatmo, Davis, Weatherflow a ďalšie",
  "settings.windDirectionConvention": "Šípka smeru vetra",
  "settings.windDirectionConventionDescription": "Vyberte spôsob zobrazenia šípok smeru vetra",
  "settings.windDirectionMeteorological": "Smer pôvodu",
  "settings.windDirectionMeteorologicalDescription": "Šípka ukazuje, odkiaľ vietor fúka (meteorologická konvencia)",
  "settings.windDirectionOceanographic": "Smer prúdenia",
  "settings.windDirectionOceanographicDescription": "Šípka ukazuje, kam vietor fúka (oceánografická konvencia)",
  "units.absolutePressure": "Absolútny tlak",
  "units.airDensity": "Hustota vzduchu",
  "units.airGap": "Vzduchová medzera",
  "units.apparentTemperature": "Zdanlivá teplota",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Priem.",
  "units.avg_wind": "Priemerný vietor",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Teplota čiernej gule",
  "units.boilerOn": "Kotol ZAPNUTÝ",
  "units.co2": "CO2",
  "units.conductivity": "Vodivosť",
  "units.coolingDegreeDays": "Ochladzovacie dni",
  "units.dailyHeatingDuration": "Denné trvanie vykurovania",
  "units.dailyPrecipitation": "Denné zrážky",
  "units.dailyRain": "Denný dážď",
  "units.degreeDay": "Stupňodeň",
  "units.degreeDayShort": "VD",
  "units.depth": "Hĺbka",
  "units.depthSensors": "Senzory hĺbky",
  "units.dewPoint": "Rosný bod",
  "units.distance": "Vzdialenosť",
  "units.downTrend": "dole",
  "units.E": "V",
  "units.E_long": "Východ",
  "units.ENE": "VSV",
  "units.ENE_long": "Východ-Severovýchod",
  "units.ESE": "VJV",
  "units.ESE_long": "Východ-Juhovýchod",
  "units.ET": "Evapotranspirácia",
  "units.ETshort": "ET",
  "units.feelLike": "Pocitovo",
  "units.feelsLike": "Pocitovo",
  "units.footMile": "Stopy, míle",
  "units.frostPoint": "Bod mrazu",
  "units.gust": "Náraz vetra",
  "units.heatIndex": "Tepelný index",
  "units.heatingDegreeDays": "Vykurovacie dni",
  "units.heatingPower": "Výkon vykurovania",
  "units.humidex": "Humidex",
  "units.humidity": "Vlhkosť",
  "units.inch": "Palec",
  "units.inchOfMercury": "Palec ortuti",
  "units.kilometerPerHour": "Kilometre za hodinu",
  "units.knot": "Uzol",
  "units.last12Hours": "Posledných 12 hodín",
  "units.last24Hours": "Posledných 24 hodín",
  "units.last3Hours": "Posledné 3 hodiny",
  "units.last6Hours": "Posledných 6 hodín",
  "units.lastHour": "Posledná hodina",
  "units.lastLightningImpact": "Posledný úder blesku",
  "units.lastMeasure": "Posledné meranie",
  "units.leafSensors": "Listové senzory",
  "units.leafWetness": "Vlhkosť listov",
  "units.lightningDistance": "Vzdialenosť",
  "units.lightningStrikeCount": "Počet úderov blesku",
  "units.lightningStrikeDistance": "Vzdialenosť úderu blesku",
  "units.max": "Max.",
  "units.max_gust": "Max. náraz vetra",
  "units.max_wind": "Max. vietor",
  "units.meterKilometer": "Metre, kilometre",
  "units.meterPerSecond": "Metre za sekundu",
  "units.milePerHour": "Míle za hodinu",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimeter",
  "units.millimeterOfMercury": "Milimeter ortuti",
  "units.min": "Min.",
  "units.N": "S",
  "units.N_long": "Sever",
  "units.NE": "SV",
  "units.NE_long": "Severovýchod",
  "units.NNE": "SSV",
  "units.NNE_long": "Sever-Severovýchod",
  "units.NNW": "SSZ",
  "units.NNW_long": "Sever-Severozápad",
  "units.noise": "Hluk",
  "units.normalizedHeatingCoefficient": "Normalizovaný koeficient vykurovania",
  "units.NW": "SZ",
  "units.NW_long": "Severozápad",
  "units.O3": "Ozón",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Zrážky",
  "units.pressure": "Tlak",
  "units.rain": "Dážď",
  "units.rainRate": "Intenzita dažďa",
  "units.referenceTemperature": "Referenčná teplota",
  "units.relativePressure": "Relatívny tlak",
  "units.S": "J",
  "units.S_long": "Juh",
  "units.SE": "JV",
  "units.SE_long": "Juhovýchod",
  "units.setPoint": "Určiť bod",
  "units.snow": "Sneh",
  "units.snowfall": "Sneženie",
  "units.soilMoisture": "Vlhkosť",
  "units.soilSensors": "Pôdne senzory",
  "units.solarEnergy": "Slnečná energia",
  "units.solarRadiation": "Slnečné žiarenie",
  "units.speed": "Rýchlosť",
  "units.SSE": "JJV",
  "units.SSE_long": "Juh-Juhovýchod",
  "units.SSW": "JJZ",
  "units.SSW_long": "Juh-Juhozápad",
  "units.stableTrend": "stabilný",
  "units.sum": "Súčet",
  "units.SW": "JZ",
  "units.SW_long": "Juhozápad",
  "units.temperature": "Teplota",
  "units.temperatureAndHumiditySensors": "Senzory teploty a vlhkosti",
  "units.temperatureSensors": "Senzory teploty a vlhkosti",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Dnes",
  "units.upTrend": "hore",
  "units.uv": "UV",
  "units.visibility": "Viditeľnosť",
  "units.W": "Z",
  "units.W_long": "Západ",
  "units.wetBulbGlobeTemperature": "Teplota mokrej gule.",
  "units.wetBulbTemperature": "Teplota vlhkého teplomera.",
  "units.wind": "Vietor",
  "units.windChill": "Ochladenie vetra",
  "units.windDirection": "Smer vetra",
  "units.windRun": "Priebeh vetra",
  "units.windRunDescription": "Priebeh vetra je celková vzdialenosť vetra za určité časové obdobie",
  "units.WNW": "ZSZ",
  "units.WNW_long": "Západ-Severozápad",
  "units.WSW": "ZJZ",
  "units.WSW_long": "Západ-Juhozápad"
}
